'use strict';
$.cookie = function(key, value, options) {
    if (arguments.length > 1 && (!/Object/.test(Object.prototype.toString.call(value)) || value === null || value === undefined)) {
        options = $.extend({}, options);
        if (value === null || value === undefined) {
            options.expires = -1
        }
        if (typeof options.expires === 'number') {
            var days = options.expires,
                t = options.expires = new Date();
            t.setDate(t.getDate() + days)
        }
        value = String(value);
        return (document.cookie = [encodeURIComponent(key), '=', options.raw ? value : encodeURIComponent(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join(''))
    }
    options = value || {};
    var decode = options.raw ? function(s) {
        return s
    } : decodeURIComponent;
    var pairs = document.cookie.split('; ');
    for (var i = 0, pair; pair = pairs[i] && pairs[i].split('='); i++) {
        if (decode(pair[0]) === key) return decode(pair[1] || '')
    }
    return null
}
if ((typeof Shopify) === 'undefined') {
    Shopify = {};
}
Shopify.moneyFormatForCurrency = function(currency) {
    var code = String(currency || '').toUpperCase(),
        symbols = {
            GEL: '₾',
            USD: '$',
            EUR: '€',
            GBP: '£',
            RUB: '₽',
            TRY: '₺',
            UAH: '₴',
            CNY: '¥',
            JPY: '¥'
        };
    return '{{amount}} ' + (symbols[code] || code || '₾');
};
// Prices remain exact cents in Shopify data, filters and calculations. Only
// the customer-facing string is truncated to whole units and space-grouped.
Shopify.formatMoney = function(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || this.money_format || '{{amount}} ₾',
        normalizedCents = cents;

    // Match Shopify's standard handling of a decimal string passed as cents.
    if (typeof normalizedCents === 'string') {
        normalizedCents = normalizedCents.replace('.', '');
    }
    normalizedCents = Number(normalizedCents);
    if (!isFinite(normalizedCents)) normalizedCents = 0;

    var wholeUnits = normalizedCents < 0
        ? Math.ceil(normalizedCents / 100)
        : Math.floor(normalizedCents / 100);
    var grouped = Math.abs(wholeUnits)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (wholeUnits < 0) grouped = '-' + grouped;

    return placeholderRegex.test(formatString)
        ? formatString.replace(placeholderRegex, grouped)
        : grouped;
};
window.novtheme = window.novtheme || {};
if ($('html').hasClass('lang-rtl')) {
    var rtl = true;
} else {
    var rtl = false;
}
var body = $('body');
var sidebarOverlay = $(".sidebar-overlay");
var currentWidth = $(window).width();
var responsive_mobile = currentWidth < 768;
var isClickEventAttached = false;
var searchCanvas = $('.nov-search__canvas');
var blockAutoComplete
novtheme.init = function() {
    novtheme.toggleMobileStyles();
    novtheme.eventBlockCart();
    novtheme.ProductDetail();
    novtheme.VerticalThumbnailProductDetail();
    novtheme.ThumbnailProductDetail();
    novtheme.load_canvas_menu();
    novtheme.NovTogglePage();
    novtheme.Countdown();
    novtheme.goToTop();
    novtheme.MenuSidebar();
    novtheme.HideShowPassword();
    novtheme.NovSearchToggle();
    novtheme.SearchAutoComplete();
    novtheme.tooltip();
    novtheme.Nov_iframe_video();
    novtheme.MegaMenuSlider();
    novtheme.LoadmoreByButton();
    novtheme.Mainmenu();
    novtheme.CollectionPage();
    novtheme.CollectionPageLoadmore();
    novtheme.NovAccordion();
    novtheme.ObserverActive();
    novtheme.LookBook();
    novtheme.LanguageCountry();
    novtheme.CartExtent();
    novtheme.AddActive();
    novtheme.Header_mobile();
    novtheme.Copy();
    novtheme.StickyHeader();
    novtheme.ParallaxImage();
    novtheme.BtnSlider();
    novtheme.CollectionTab();
    novtheme.NumberAnimate();
    novtheme.FakeOrder();
    novtheme.VerticalMenu();
    novtheme.Parallax();
    novtheme.OverlayBlur();
    novtheme.ToggleUpDown();
    novtheme.Comparisons();
    novtheme.Marquee();
    novtheme.TextAnimate();
    novtheme.BlockOverflowScroll();
    novtheme.ElementHeight();
    novtheme.ScrollView();
}; 
//Tooltip, activated by hover event
novtheme.tooltip = function() {
    body.tooltip({
        selector: "[data-toggle='tooltip']",
        container: "body"
    });
};
novtheme.swapChildren = function(obj1, obj2) {
    var temp = obj2.children().detach();
    obj2.empty().append(obj1.children().detach());
    obj1.append(temp);
};
novtheme.toggleMobileStyles = function() {
    if (responsive_mobile) {
        $("*[id^='_desktop_']").each(function(idx, el) {
            var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
            if (target) {
                novtheme.swapChildren($(el), target);
            }
        });
    } else {
        $("*[id^='_mobile_']").each(function(idx, el) {
            var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
            if (target) {
                novtheme.swapChildren($(el), target);
            }
        });
    }
};
novtheme.toggleSticky = function(action) {
    if (action == true) {
        $("*[class^='contentsticky_']").each(function(idx, el) {
            var target = $('.' + el.classList['0'].replace('contentsticky_', 'contentstickynew_'));
            if (target.length) {
                novtheme.swapChildren($(el), target);
            }
        });
    } else {
        $("*[class^='contentstickynew_']").each(function(idx, el) {
            var target = $('.' + el.classList['0'].replace('contentstickynew_', 'contentsticky_'));
            if (target.length) {
                novtheme.swapChildren($(el), target);
            }
        });
    }
};
novtheme.StickyHeader = function() {
    const $siteHeader = $('.site-header');
    if ($siteHeader.hasClass('sticky-header')) {
        let isHeaderSticky = false;
        let prevScroll = $(window).scrollTop();
        const headerHeight = $siteHeader.outerHeight();
        $(window).on('scroll', function() {
           const scrollTop = $(this).scrollTop();
           if (scrollTop < prevScroll && scrollTop > headerHeight) {
                if (!isHeaderSticky) {
                    $('#header-sticky').addClass('sticky-header-active');
                    $siteHeader.css('height', headerHeight);
                    novtheme.toggleSticky(true)
                    isHeaderSticky = true;
                }
            } else {
                if (isHeaderSticky) {
                    $('#header-sticky').removeClass('sticky-header-active');
                    $siteHeader.css('height', 'auto');
                    novtheme.toggleSticky(false)
                    isHeaderSticky = false;
                }
            }
          prevScroll = scrollTop;
        });
    }
    if (responsive_mobile) {
        var headerMobile = $('.header-mobile');
        if (headerMobile.hasClass('sticky-header-mobile')) {
            var mobileMenu = $('#mobile_menu');
            var height_m = $('.site-header').height();
            var flag_m = true;
            var offsetTop_m = 0;
            var height_promotion = 0;
            $(window).scroll(function() {
                var scrollTop_m = $(window).scrollTop();
                if (scrollTop_m < offsetTop_m && scrollTop_m > height_m) {
                    if (flag_m == true) {
                        headerMobile.addClass('sticky-header-active');
                        flag_m = false;
                    }
                } else {
                    if (flag_m == false) {
                        headerMobile.removeClass('sticky-header-active');
                        flag_m = true;
                    }
                }
                offsetTop_m = scrollTop_m;
                if ($(window).scrollTop() > height_m) {
                    headerMobile.addClass('down');
                } else {
                    headerMobile.removeClass('down');
                }
            });
        }
    }
    var topHeader = $('.site-header').offset().top;
    $('.site-header').css('--offset-top', topHeader + 'px');
    $('.header-content').css('--height', $('.header-content').outerHeight() + 'px');
};
novtheme.load_canvas_menu = function() {
    var $main_menu = $(".site-nav-mobile");
    if ($("#canvas-main-menu").length < 1 && $main_menu.length > 0) {
        var $menu = $main_menu.parent().clone();
        $menu.attr("id", "canvas-main-menu");
        $($menu).find(".menu").removeAttr('id');
        $('.canvas-menu').prepend($menu);
        $menu.mmenu({
            offCanvas: false,
            "navbar": {
                "title": false
            }
        });
    }
    $('.mm-next').click(function(){
        $('.navmenu-product .grid--view-items').slick('refresh');
    })
};
novtheme.Header_mobile = function() {
    var mobileMenu = $('#mobile_menu'),
        mobilesearch = $('#mobile_search'),
        showMegamenu = $('#show-megamenu'),
        mobileBtnSearch = $('.mobile-btn_search');
    var header4CategoryTriggers = $('.contentsticky_vertical .btn-vertical, .contentstickynew_vertical .btn-vertical');
    var menuTriggers = showMegamenu.add($('.site-nav--btn')).add(header4CategoryTriggers);
    var lastMenuTrigger = $();
    var updateMobileSearchTrigger = function(trigger, isOpen) {
        trigger.attr('aria-expanded', isOpen ? 'true' : 'false').each(function() {
            var label = isOpen ? $(this).data('close-label') : $(this).data('search-label');
            if (label) $(this).attr('aria-label', label);
        });
    };
    var closeMobileMenu = function(returnFocus) {
        var wasOpen = mobileMenu.hasClass('act');
        sidebarOverlay.add(mobileMenu).removeClass('act');
        menuTriggers.removeClass('act').attr('aria-expanded', 'false');
        body.css('overflow', 'auto');
        if (wasOpen && typeof window.CustomEvent === 'function') {
            document.dispatchEvent(new window.CustomEvent('merlons:mobile-menu-close'));
        }
        if (returnFocus && wasOpen) {
            var visibleMenuTrigger = lastMenuTrigger.filter(':visible').first();
            if (!visibleMenuTrigger.length) visibleMenuTrigger = menuTriggers.filter(':visible').first();
            if (visibleMenuTrigger.length) visibleMenuTrigger.get(0).focus();
        }
    };
    var openMobileMenu = function(trigger) {
        lastMenuTrigger = trigger && trigger.length ? trigger : menuTriggers.filter(':visible').first();
        menuTriggers.addClass('act').attr('aria-expanded', 'true');
        sidebarOverlay.add(mobileMenu).addClass('act');
        body.css('overflow', 'hidden');
        var closeButton = mobileMenu.find('[data-merlons-mobile-menu-close]').first();
        if (closeButton.length) closeButton.get(0).focus({ preventScroll: true });
    };
    var toggleMobileMenu = function(trigger) {
        if (mobileMenu.hasClass('act')) closeMobileMenu(true);
        else openMobileMenu(trigger);
    };
    novtheme.mobileMenu = { open: openMobileMenu, close: closeMobileMenu, toggle: toggleMobileMenu };
    var closeMobileSearch = function(returnFocus) {
        mobilesearch.add(mobileBtnSearch).removeClass('act');
        mobilesearch.find('.search_overlay').removeClass('act');
        updateMobileSearchTrigger(mobileBtnSearch, false);
        body.css('overflow', 'auto');
        if (returnFocus) {
            var visibleSearchTrigger = mobileBtnSearch.filter(':visible').first();
            if (visibleSearchTrigger.length) visibleSearchTrigger.get(0).focus();
        }
    };
    showMegamenu.off('click.merlonsMenu keydown.merlonsMenu').on('click.merlonsMenu keydown.merlonsMenu', function(event){
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (event.type === 'keydown') event.preventDefault();
        toggleMobileMenu($(this));
        mobilesearch.add(mobileBtnSearch).removeClass('act');
        mobilesearch.find('.search_overlay').removeClass('act');
        updateMobileSearchTrigger(mobileBtnSearch, false);
    });
    mobileBtnSearch.off('click.merlonsSearch keydown.merlonsSearch').on('click.merlonsSearch keydown.merlonsSearch', function(event){
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (event.type === 'keydown') event.preventDefault();
        var searchIsOpen = $(this).hasClass('act');
        if (searchIsOpen) {
            closeMobileSearch(false);
        } else {
            if (mobileMenu.hasClass('act')) closeMobileMenu(false);
            $(this).addClass('act');
            mobilesearch.addClass('act');
            mobilesearch.find('.search_overlay').addClass('act');
            updateMobileSearchTrigger($(this), true);
            body.css('overflow', 'hidden');
            var mobileSearchInput = mobilesearch.find('input[name="q"]');
            if (mobileSearchInput.length) mobileSearchInput.get(0).focus();
        }
        sidebarOverlay.add(menuTriggers).add(mobileMenu).removeClass('act');
        menuTriggers.attr('aria-expanded', 'false');
    });
    mobilesearch.find('.search_overlay').off('click.merlonsMobileSearch').on('click.merlonsMobileSearch', function() {
        closeMobileSearch(mobilesearch.hasClass('act') || mobileBtnSearch.hasClass('act'));
    });
    mobileMenu.find('[data-merlons-mobile-menu-close]').off('click.merlonsMenu').on('click.merlonsMenu', function() {
        closeMobileMenu(true);
    });
    sidebarOverlay.off('click.merlonsMenu').on('click.merlonsMenu', function() {
        if (mobileMenu.hasClass('act')) closeMobileMenu(true);
    });
    $(document).off('keydown.merlonsMobileSearch').on('keydown.merlonsMobileSearch', function(event) {
        if (event.key === 'Escape' && (mobilesearch.hasClass('act') || mobileBtnSearch.hasClass('act'))) {
            event.preventDefault();
            closeMobileSearch(true);
        }
    });
    $(document).off('keydown.merlonsMenu').on('keydown.merlonsMenu', function(event) {
        if (event.key === 'Escape' && mobileMenu.hasClass('act')) {
            event.preventDefault();
            closeMobileMenu(true);
            return;
        }
        if (event.key !== 'Tab' || !mobileMenu.hasClass('act')) return;
        var focusable = mobileMenu.find('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])').filter(function() {
            var panel = $(this).closest('.mm-panel');
            return $(this).is(':visible') && (!panel.length || (panel.hasClass('mm-opened') && !panel.hasClass('mm-subopened')));
        });
        var closeButton = mobileMenu.find('[data-merlons-mobile-menu-close]').first();
        if (!focusable.length && closeButton.length) focusable = closeButton;
        if (!focusable.length) return;
        var first = focusable.first().get(0);
        var last = focusable.last().get(0);
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        } else if (!mobileMenu.has(document.activeElement).length) {
            event.preventDefault();
            first.focus();
        }
    });
    var hasHeader4Category = $('.contentsticky_vertical, .contentstickynew_vertical').length > 0;
    var wasDesktopMenuViewport = window.matchMedia('(min-width: 1200px)').matches;
    $(window).off('resize.merlonsMobileSearch').on('resize.merlonsMobileSearch', function() {
        if (window.matchMedia('(min-width: 768px)').matches && (mobilesearch.hasClass('act') || mobileBtnSearch.hasClass('act'))) {
            closeMobileSearch(false);
        }
        var isDesktopMenuViewport = window.matchMedia('(min-width: 1200px)').matches;
        if (hasHeader4Category) {
            if (isDesktopMenuViewport && !wasDesktopMenuViewport) {
                closeMobileMenu(false);
                $('#desktopVerticalMenu .site-nav-vertical, #mobileVerticalMenu .site-nav-vertical').removeClass('act');
            }
        } else if (window.matchMedia('(min-width: 768px)').matches && mobileMenu.hasClass('act')) {
            closeMobileMenu(false);
        }
        wasDesktopMenuViewport = isDesktopMenuViewport;
    });
};
novtheme.Copy = function () {
    $('.copy-btn').click(function() {
        const el = $(this);
        const copy = el.data('copy');
        const copied = el.data('copied');
        const input = el.siblings('input')[0];
        input.select();
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        el.find('span').text(copied);
        setTimeout(() => el.find('span').text(copy), 2500);
    });
};
novtheme.ProductDetail = function() {
    jQuery('product-variant-swatch :radio, product-variant-dropdown select').change(function() {
      var optionValue = jQuery(this).val();
      jQuery(this).parents('fieldset, .product-form__input').find('.variant_current').text(optionValue);
      // Style image grid and scroll
      if ($(window).width() > 991 ) {
        if ($('.product-template__imggrid').length > 0 || $('.product-template__scroll').length > 0) {
          setTimeout(function() {
            var parent = $('.product-template__imggrid .proFeaturedImage, .product-template__scroll .proFeaturedImage'),
                active = parent.find('.act'),
                positi = active.data('position'),
                offset = active.offset().top;
                $("body,html").animate({scrollTop: offset}, "normal");
                $('.thumbItem').removeClass('active');
                $('.thumbItem[data-position="'+ positi +'"]').addClass('active');
          }, 200);
        }
      }
    });
    if ($('.product-single__stick-add').length > 0) {
      var winHeight = $(window).height();
      $(window).scroll(function() {
        if ($(window).scrollTop() > winHeight) {
          $('.product-single__stick-add').addClass('act');
        } else {
          $('.product-single__stick-add').removeClass('act');
        }
      });
      $(window).on('load', function() {
        if($('.product-single__stick-add').length > 0 && currentWidth>=768) {
          var h = $('.product-single__stick-add').height();
          body.css('padding-bottom', h)
        }
      })
    }
};
novtheme.VerticalThumbnailProductDetail= function() {
    var proTemplateScroll = $('.product-template__scroll');
    var proFeaturedImage = proTemplateScroll.find('.proFeaturedImage');
    if (currentWidth > 991 && $('.template-product').length > 0 ) {
        $(window).on('mousewheel DOMMouseScroll wheel', (function(e) {
            proFeaturedImage.find('.item.act').each(function(){
                var item = $(this),
                    p = item.data('position'),
                    hd = item.height()/2,
                    srt = $(window).scrollTop(),
                    y = e.originalEvent.deltaY,
                    offset_top = item.offset().top;
                if (y > 0) {
                    if (p < proFeaturedImage.find('.item').length) {
                        var npd = p + 1;
                    } else {
                        var npd = p;
                    }
                    if (srt > offset_top + hd) {
                       item.removeClass('act');
                       proFeaturedImage.find('.item[data-position="'+ npd +'"]').addClass('act');
                       $('.thumbItem').removeClass('active');
                       $('.thumbItem[data-position="'+ npd +'"]').addClass('active');
                    }
                } else {
                    if (p > 1) {
                        var npu = p - 1;
                    } else {
                        var npu = p;
                    }
                    if (srt < offset_top - hd) {
                        item.removeClass('act');
                        proFeaturedImage.find('.item[data-position="'+ npu +'"]').addClass('act');
                        $('.thumbItem').removeClass('active');
                        $('.thumbItem[data-position="'+ npu +'"]').addClass('active');
                    }
                }
                proTemplateScroll.find('.thumb_vertical_slick').slick('slickGoTo', p);
            });
        }));
        proTemplateScroll.find('.thumbItem').click(function(){
            var p = $(this).data('position');
            proTemplateScroll.find('.thumbItem').removeClass('active');
            $(this).addClass('active');
            proFeaturedImage.find('.item').removeClass('act');
            proFeaturedImage.find('.item[data-position="'+ p +'"]').addClass('act');
            var ost = proFeaturedImage.find('.item.act').offset().top;
            $("body,html").animate({scrollTop: ost - 60}, "normal");
        });
    }
    if (currentWidth < 992 ) {
        $('.product-template__scroll .proFeaturedImage, .product-template__imggrid .proFeaturedImage').slick({
            slide: '.item',
            infinite: false,
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }).on('afterChange',function(e,o){
            $('iframe').each(function(){
                $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            });
            proFeaturedImage.find('.slick-slide:not(.slick-active) video').trigger('pause');
        });
        proFeaturedImage.on('afterChange', function(event, slick, currentSlide) {
            $('#productThumbs .thumb_slick').slick('slickGoTo', currentSlide);
            $('#productThumbs .thumb_slick').find('.slick-slide').removeClass('active');
            $('#productThumbs .thumb_slick').find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('active');
        });

        $('.product-template__scroll .thumb_slick').on('click', '.thumbItem', function(event) {
            event.preventDefault();
            $('.thumb_slick').find('.slick-slide').removeClass('active');
            $(this).addClass('active');
            var goToSingleSlide = $(this).data('slick-index');
            $('.product-template__scroll .proFeaturedImage').slick('slickGoTo', goToSingleSlide);
        });
        $('product-variant-swatch label').click(function () {
            setTimeout(function() {
                var dindex = $('.product-template__scroll .proFeaturedImage, .product-template__imggrid .proFeaturedImage').find('.item.act').attr('data-slick-index');
                $('.product-template__scroll .proFeaturedImage, .product-template__imggrid .proFeaturedImage').slick('slickGoTo', dindex);
            }, 300);
        })
    }
};
novtheme.ThumbnailProductDetail = function() {
    var $FeaturedImage = $('.FeaturedImage_slick');
    var $ThumbImage = $('#productThumbs .thumb_slick');
    var syncProductGallerySlideSemantics = function() {
        // Image galleries use native links, so their pagination must not impersonate tabs/panels.
        if (!$FeaturedImage.find('a.item_img').length) return;
        $FeaturedImage.find('.slick-slide').each(function() {
            var $slide = $(this);
            var describedBy = ($slide.attr('aria-describedby') || '').split(/\s+/).filter(function(id) {
                return id && !/^slick-slide-control/.test(id);
            });
            if ($slide.is('a.item_img') && $slide.attr('role') === 'tabpanel') {
                $slide.removeAttr('role');
            } else if (!$slide.is('a.item_img') && $slide.attr('role') === 'tabpanel') {
                $slide.attr('role', 'group');
            }
            if (describedBy.length) {
                $slide.attr('aria-describedby', describedBy.join(' '));
            } else {
                $slide.removeAttr('aria-describedby');
            }
        });
        $FeaturedImage.find('.slick-dots').each(function() {
            var $dots = $(this);
            $dots.removeAttr('role').find('li').removeAttr('role').find('button').each(function() {
                var $button = $(this);
                $button.removeAttr('role aria-selected aria-controls').attr('tabindex', '0');
                if ($button.closest('li').hasClass('slick-active')) {
                    $button.attr('aria-current', 'true');
                } else {
                    $button.removeAttr('aria-current');
                }
            });
        });
    };
    var scheduleProductGallerySlideSemantics = function() {
        syncProductGallerySlideSemantics();
        window.setTimeout(syncProductGallerySlideSemantics, 0);
    };
    $FeaturedImage
        .off('.merlonsProductGallerySemantics')
        .on('init.merlonsProductGallerySemantics reInit.merlonsProductGallerySemantics afterChange.merlonsProductGallerySemantics breakpoint.merlonsProductGallerySemantics', scheduleProductGallerySlideSemantics);
    var useAdaptiveHeight = !$FeaturedImage.closest('.product-template__lefttwo').length;
    var dots = $FeaturedImage.data("dots"),
        nav = $FeaturedImage.data("nav"),
        draggable = $FeaturedImage.data("draggable"),
        items = $FeaturedImage.data("items"),
        items_lg = $FeaturedImage.data("items_lg"),
        items_md = $FeaturedImage.data("items_md"),
        items_sm = $FeaturedImage.data("items_sm"),
        items_xs = $FeaturedImage.data("items_xs"),
        qtyItem = $ThumbImage.find('.item').length;
        if (qtyItem < 20) {
            var dotXs = true;
        }else {
            var dotXs = false;
        }
    $FeaturedImage.slick({
        slide: '.item',
        nextArrow: '<button type="button" class="arrow-next" aria-label="Next"><svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>',
        prevArrow: '<button type="button" class="arrow-prev" aria-label="Previous"><svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg></button>',
        slidesToShow: items,
        slidesToScroll: items,
        dots: dots,
        arrows: nav,
        adaptiveHeight: useAdaptiveHeight,
        infinite: true,
        speed: 500,
        cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
        rtl: rtl,
        draggable: draggable,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: items_lg,
                    slidesToScroll: items_lg,
                    vertical: vertical_lg,
                    verticalSwiping: vertical_lg,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: items_md,
                    slidesToScroll: items_md
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: items_sm,
                    slidesToScroll: items_sm,
                    dots: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: items_xs,
                    slidesToScroll: items_xs,
                    dots: dotXs
                }
            }
        ]
    });
    syncProductGallerySlideSemantics();

    var infinite = $ThumbImage.data("loop"),
        dots = $ThumbImage.data("dots"),
        nav = $ThumbImage.data("nav"),
        vertical = $ThumbImage.data("vertical"),
        vertical_lg = $ThumbImage.data("vertical_lg"),
        vertical_md = $ThumbImage.data("vertical_md"),
        vertical_sm = $ThumbImage.data("vertical_sm"),
        items = $ThumbImage.data("items"),
        items_lg = $ThumbImage.data("items_lg"),
        items_md = $ThumbImage.data("items_md"),
        items_sm = $ThumbImage.data("items_sm"),
        items_xs = $ThumbImage.data("items_xs");
        if (vertical == true) {
            rtl = false;
        }
    $ThumbImage.on('init', function(event, slick) {
        $(this).find('.slick-slide.slick-current').addClass('active');
    })
    .slick({
        nextArrow: '<button type="button" class="arrow-next" aria-label="Next"><svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>',
        prevArrow: '<button type="button" class="arrow-prev" aria-label="Previous"><svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg></button>',
        infinite: infinite,
        slidesToShow: items,
        slidesToScroll: 1,
        dots: dots,
        arrows: nav,
        rtl: rtl,
        vertical: vertical,
        verticalSwiping: vertical,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: items_lg,
                    slidesToScroll: 1,
                    vertical: vertical_lg,
                    verticalSwiping: vertical_lg,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: items_md,
                    slidesToScroll: 1,
                    vertical: vertical_md,
                    verticalSwiping: vertical_md,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: items_sm,
                    slidesToScroll: 1,
                    vertical: vertical_sm,
                    verticalSwiping: vertical_sm,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: items_xs,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false
                }
            }
        ]
    });
    
    $FeaturedImage.on('afterChange', function(event, slick, currentSlide) {
        $ThumbImage.slick('slickGoTo', currentSlide);
        $ThumbImage.find('.slick-slide.active').removeClass('active');
        $ThumbImage.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('active');
        $FeaturedImage.find('.slick-slide:not(.slick-active) iframe').each(function(){
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        });
        $FeaturedImage.find('.slick-slide:not(.slick-active) video').trigger('pause');
        // Type thumb grid
        $('.thumbgrid .thumbItem').removeClass('active');
        $('.thumbgrid .thumbItem[data-position="' + currentSlide + '"]').addClass('active');
    });
    $ThumbImage.on('click', '.slick-slide', function(event) {
        event.preventDefault();
        $ThumbImage.find('.slick-slide.active').removeClass('active');
        $(this).addClass('active');
        var position = $(this).data('slick-index');
        $FeaturedImage.slick('slickGoTo', position);
    });
    // Type thumb grid
    $('.thumbgrid .thumbItem').on('click', function(event) {
        event.preventDefault();
        var position = $(this).data('position');
        $FeaturedImage.slick('slickGoTo', position);
    });
    $('product-variant-swatch :radio, product-variant-dropdown select').change(function() {
        setTimeout(function() {
            var dindex = $FeaturedImage.find('.item.act').attr('data-slick-index');
            $FeaturedImage.slick('slickGoTo', dindex);
        }, 300);
    })
    if (responsive_mobile) {
        $('.thumbgrid .thumblist').slick({
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 4
        })
    }
};
novtheme.Countdown = function() {
    function startCountdown($countdown, showDays, restartCountdown) {
        var finalDate = $countdown.data('countdown');
        var showDays = showDays || false;
        var restartCountdown = restartCountdown || false;
        var finalDateGetTime = new Date(finalDate).getTime();
        var NewfinalDate = "";
        var now = new Date();
        if (finalDateGetTime - now.getTime() < 0 && restartCountdown == true) {
            NewfinalDate = new Date(now.getTime() + (86400 - (now.getHours() * 60 * 60) - (now.getMinutes() * 60) - now.getSeconds()) * 1000);
        } else {
            NewfinalDate = finalDate;
        }
        var dayString = showDays ? '<div class="item-time"><span class="data-number">%D</span><span class="name-time">'+ theme.strings.days +'</span></div>' : '';
        var countdown_format = dayString
                           + '<div class="item-time"><span class="data-number">%H</span><span class="name-time">'+ theme.strings.hours +'</span></div>'
                           + '<div class="item-time"><span class="data-number">%M</span><span class="name-time">'+ theme.strings.minutes +'</span></div>'
                           + '<div class="item-time"><span class="data-number">%S</span><span class="name-time">'+ theme.strings.seconds +'</span></div>';
        $countdown.countdown(NewfinalDate, function(event) {
            $countdown.html(event.strftime(countdown_format));
        }).on('finish.countdown', function() {
            if (restartCountdown) {
                startCountdown($countdown, showDays, restartCountdown);
            }
        });
    }

    $('[data-countdown]').each(function() {
        var showDays = $(this).data('show-days') || false;
        var restartCountdown = $(this).data('restart') || false;
        startCountdown($(this), showDays, restartCountdown);
    });
};
novtheme.eventBlockCart = function(e) {
    $('.header-cart').click(function(){
        sidebarOverlay.addClass('act');
        $("#desktop_cart").addClass('active');
        $('.nov_item_act, .nov_btn_act').removeClass('act');
        if (responsive_mobile) {
            body.addClass('open-canvans-cart');
            $('#show-megamenu, #mobile_menu').removeClass('act');
        }
    });
    $('.close_cart').click(function(){
        sidebarOverlay.removeClass('act');
        $('#desktop_cart').removeClass('active');
        $('.cart_extend').removeClass('act');
        $('.extend--label__item').removeClass('act').each(function() {
            var title = $(this).data('title');
            $(this).attr('data-original-title', title);
        });
        $('.cart_extend--label').removeClass('act');
        $('.nov_item_act, .nov_btn_act').removeClass('act');
        if (responsive_mobile) {
            body.removeClass('open-canvans-cart');
        }
    });
};
novtheme.NovTogglePage = function() {
    $('.nov-toggle-page[data-target="#mobile-pageaccount"]').on('click', function(e) {
        var target = $(this).data('target');
        $(target).hasClass('active') ? ($(target).removeClass('active'), sidebarOverlay.removeClass('act').css('z-index', '99')) : ($(target).addClass('active'), sidebarOverlay.addClass('act').css('z-index', '999'));
        e.preventDefault();
    });
    $('.mobile-boxpage .close-box').on('click', function(e) {
        $(this).parents('.mobile-boxpage').removeClass('active');
        sidebarOverlay.removeClass('act')
        e.preventDefault();
    });
};
novtheme.HideShowPassword = function() {
    $('.hide_show_password').show();
    $('.hide_show_password span').addClass('show')
    $('.hide_show_password span').click(function(){
        if( $(this).hasClass('show')) {
            $(this).html('<i class="zmdi zmdi-eye"></i>');
            $('input[name="customer[password]"]').attr('type','text');
            $(this).removeClass('show');
        } else {
            $(this).html('<i class="zmdi zmdi-eye-off"></i>');
            $('input[name="customer[password]"]').attr('type','password');
            $(this).addClass('show');
        }
    });
    $('form button[type="submit"]').on('click', function(){
        $('.hide_show_password span').text('Show').addClass('show');
        $('.hide_show_password').parent().find('input[name="customer[password]"]').attr('type','password');
    });
    $('.login_switch').on('click', function() {
        if ($(this).hasClass('login-btn')) {
            $('.login_switch_register--toggle').css('transform', 'translate(0)');
            $('#p_login').slideDown();
            $('#p_register').slideUp();
        } else {
            if (rtl == true) {
                $('.login_switch_register--toggle').css('transform', 'translate(-100%)');
            }
            else {
                $('.login_switch_register--toggle').css('transform', 'translate(100%)');
            }
            $('#p_login').slideUp();
            $('#p_register').slideDown();
        }
    });
};
novtheme.NovSearchToggle = function() {
    searchCanvas.find('.search_autocomplete').removeClass('hidden');
    $('.search-header__input').focus(function(){
        var currentInput = $(this);
        var currentForm = currentInput.closest('form.search-header-inline');
        var isMobileHeaderSearch = currentInput.closest('.header-mobile #mobile_search').length > 0;
        currentInput.addClass('focus');
        if (searchCanvas.length == 0) {
            var currentAutocomplete = currentForm.find('.search_autocomplete');
            var hasSearchContent = currentAutocomplete.find('.search_trend').length > 0 || currentAutocomplete.find('.search-results__block:visible').length > 0;
            if (hasSearchContent) {
                if (isMobileHeaderSearch) {
                    currentAutocomplete.stop(true, true).show();
                } else {
                    currentAutocomplete.stop(true, true).slideDown();
                }
            } else {
                currentAutocomplete.hide();
            }
        }
        if (isMobileHeaderSearch) {
            currentForm.find('.search_overlay').addClass('act');
        } else {
            setTimeout(function(){
                currentForm.find('.search_overlay').addClass('act');
            }, 200);
        }
    });
    $(document).on('click', function(event) {
        if ($(event.target).is('.site-header__search input') == !1) {
            if (currentWidth > 767) {
                if (searchCanvas.length == 0) {
                    $('.search_autocomplete').slideUp();
                }
                $('.search_overlay').removeClass('act');
            }
            if ($('.search-header__input').val().length > 0) {
                $('.search-header__input').addClass('focus');
            } else {
                $('.search-header__input').removeClass('focus');
            }
        }
    })
};
novtheme.SearchAutoComplete = function () {
    $('form.search-header-inline[role="search"]').css('position','relative').each(function() {

        var currentAjaxRequest = null;
        var searchDebounceTimer = null;
        var searchRequestToken = 0;
        var cancelPendingAutocomplete = function() {
            searchRequestToken += 1;
            if (searchDebounceTimer != null) {
                window.clearTimeout(searchDebounceTimer);
                searchDebounceTimer = null;
            }
            if (currentAjaxRequest != null) {
                currentAjaxRequest.abort();
                currentAjaxRequest = null;
            }
        };
        var searchForm = $(this);
        var input = $(this).find('input[name="q"]');
        var dataColor = $(this).data('color');
        var searchOverlay = $(this).find('.search_overlay');
        var blockAutoComplete = $(this).find('.search_autocomplete');
        var isMobileHeaderSearch = searchForm.closest('.header-mobile #mobile_search').length > 0;
        var searchAction = searchForm.data('search-url') || searchForm.attr('action');
        var catalogAction = searchForm.data('catalog-url') || searchForm.attr('action');
        if (!searchAction) return;
        var categoryResultsLabel = searchForm.data('category-results-label') || '';
        var productResultsLabel = searchForm.data('product-results-label') || '';
        var collectionIndex = [];
        var collectionDataNode = searchForm.find('.merlons-search-collections').get(0);
        if (collectionDataNode) {
            try {
                collectionIndex = JSON.parse(collectionDataNode.textContent || '[]');
            } catch (error) {
                collectionIndex = [];
            }
        }
        var buildSearchURL = function(baseURL, term) {
            var separator = String(baseURL).indexOf('?') === -1 ? '?' : '&';
            return baseURL + separator + 'type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term);
        };
        var buildCatalogURL = function(baseURL, term) {
            var separator = String(baseURL).indexOf('?') === -1 ? '?' : '&';
            return baseURL + separator + 'q=' + encodeURIComponent(term);
        };
        var normalizeSearchTerm = function(value, trimForSubmit) {
            var normalized = String(value || '')
                .replace(/[\u0000-\u001F\u007F-\u009F]/g, ' ')
                .replace(/[\u00AD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180F\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0]/g, '')
                .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, ' ');
            return trimForSubmit ? normalized.trim() : normalized;
        };
        var normalizeComparableTerm = function(value) {
            return normalizeSearchTerm(value, true)
                .normalize('NFKC')
                .toLocaleLowerCase()
                .replace(/[-_/]+/g, ' ')
                .replace(/[.,;:!?()[\]{}"'“”„’]+/g, ' ')
                .replace(/\s+/g, ' ');
        };
        // Shopify does not currently stem Georgian singular and plural forms
        // consistently. Product titles are normally singular, while collection
        // titles are plural, so keep a small, domain-specific equivalence list
        // instead of applying unsafe generic Georgian suffix rewriting.
        var georgianSearchInflections = [
            ['შემრევი', 'შემრევები'],
            ['საშხაპე', 'საშხაპეები'],
            ['შხაპი', 'შხაპები'],
            ['ტრაპი', 'ტრაპები'],
            ['ხელსაბანი', 'ხელსაბანები'],
            ['უნიტაზი', 'უნიტაზები'],
            ['პისუარი', 'პისუარები'],
            ['აბაზანა', 'აბაზანები'],
            ['აქსესუარი', 'აქსესუარები'],
            ['სარკე', 'სარკეები'],
            ['სკამი', 'სკამები'],
            ['სავარძელი', 'სავარძლები'],
            ['დივანი', 'დივნები'],
            ['პუფი', 'პუფები'],
            ['მაგიდა', 'მაგიდები'],
            ['ბენჩი', 'ბენჩები'],
            ['ჭაღი', 'ჭაღები'],
            ['სანათი', 'სანათები'],
            ['ფილა', 'ფილები']
        ];
        var replaceSearchTokens = function(term, direction) {
            // Only transform recognized Georgian category words. Keeping the
            // original token for everything else preserves exact product codes
            // such as 09039.230.A, including punctuation and letter case.
            var tokens = normalizeSearchTerm(term, true).split(/\s+/);
            return tokens.map(function(token) {
                var comparableToken = normalizeComparableTerm(token).trim();
                for (var index = 0; index < georgianSearchInflections.length; index += 1) {
                    var singular = georgianSearchInflections[index][0];
                    var plural = georgianSearchInflections[index][1];
                    if (direction === 'singular' && comparableToken === plural) return singular;
                    if (direction === 'plural' && comparableToken === singular) return plural;
                }
                return token;
            }).join(' ');
        };
        var buildComparableVariants = function(term) {
            var variants = [];
            var addVariant = function(value) {
                var normalizedValue = normalizeComparableTerm(value);
                if (normalizedValue && variants.indexOf(normalizedValue) === -1) variants.push(normalizedValue);
            };
            addVariant(term);
            addVariant(replaceSearchTokens(term, 'singular'));
            addVariant(replaceSearchTokens(term, 'plural'));
            return variants;
        };
        var canonicalProductSearchTerm = function(term) {
            // Product names describe one item and therefore predominantly use
            // singular Georgian nouns. Sending the singular equivalent avoids
            // Shopify returning unrelated products for plural-only queries.
            return replaceSearchTokens(term, 'singular');
        };
        var getSearchHighlightRanges = function(value, query) {
            var source = value == null ? '' : String(value);
            var rawQuery = query == null ? '' : String(query);
            var queryTokens = rawQuery.trim().split(/\s+/).filter(function(token) {
                return token.length > 0;
            });
            if (!source || !queryTokens.length) return [];

            var isSearchSeparator = function(character) {
                return /\s/.test(character) || ' \t-_/|.,;:!?()[]{}\'“”„’+*=<>\\'.indexOf(character) !== -1;
            };
            var folded = function(input, loose) {
                var normalized = '';
                var starts = [];
                var ends = [];
                for (var index = 0; index < input.length; index += 1) {
                    var character = input.charAt(index);
                    if (loose && isSearchSeparator(character)) continue;
                    var foldedCharacter = character.normalize('NFKC').toLocaleLowerCase();
                    if (!foldedCharacter) continue;
                    normalized += foldedCharacter;
                    for (var characterIndex = 0; characterIndex < foldedCharacter.length; characterIndex += 1) {
                        starts.push(index);
                        ends.push(index + 1);
                    }
                }
                return { value: normalized, starts: starts, ends: ends };
            };
            var sourceExact = folded(source, false);
            var sourceLoose = folded(source, true);
            var ranges = [];
            var addMatches = function(sourceMap, token, loose) {
                var tokenMap = folded(token, loose);
                if (!tokenMap.value) return;
                var cursor = 0;
                var matchIndex;
                while ((matchIndex = sourceMap.value.indexOf(tokenMap.value, cursor)) !== -1) {
                    var first = sourceMap.starts[matchIndex];
                    var last = sourceMap.ends[matchIndex + tokenMap.value.length - 1];
                    if (typeof first === 'number' && typeof last === 'number') ranges.push([first, last]);
                    cursor = matchIndex + Math.max(tokenMap.value.length, 1);
                }
            };
            queryTokens.forEach(function(token) {
                addMatches(sourceExact, token, false);
                addMatches(sourceLoose, token, true);
            });
            return ranges.sort(function(left, right) {
                return left[0] - right[0] || left[1] - right[1];
            }).reduce(function(merged, range) {
                var previous = merged[merged.length - 1];
                if (previous && range[0] <= previous[1]) {
                    previous[1] = Math.max(previous[1], range[1]);
                } else {
                    merged.push(range);
                }
                return merged;
            }, []);
        };
        var appendSearchHighlightedText = function(target, value, query) {
            var source = value == null ? '' : String(value);
            var ranges = getSearchHighlightRanges(source, query);
            target.empty();
            if (!ranges.length) {
                target.append(document.createTextNode(source));
                return target;
            }
            var cursor = 0;
            ranges.forEach(function(range) {
                if (range[0] > cursor) target.append(document.createTextNode(source.slice(cursor, range[0])));
                var mark = document.createElement('mark');
                mark.className = 'merlons-search-highlight';
                mark.appendChild(document.createTextNode(source.slice(range[0], range[1])));
                target.append(mark);
                cursor = range[1];
            });
            if (cursor < source.length) target.append(document.createTextNode(source.slice(cursor)));
            return target;
        };
        var collectionMatchScore = function(item, variants) {
            var title = normalizeComparableTerm(item.title || '');
            var handle = normalizeComparableTerm(item.handle || '');
            var aliases = Array.isArray(item.aliases) ? item.aliases : [];
            var titleTokens = title.split(' ');
            var bestScore = 0;
            variants.forEach(function(variant) {
                if (title === variant) bestScore = Math.max(bestScore, 1000);
                else if (title.indexOf(variant + ' ') === 0) bestScore = Math.max(bestScore, 900);
                else if (titleTokens.indexOf(variant) !== -1) bestScore = Math.max(bestScore, 800);
                else if (title.indexOf(variant) !== -1) bestScore = Math.max(bestScore, 600);
                if (handle === variant) bestScore = Math.max(bestScore, 500);
                else if (handle.indexOf(variant) !== -1) bestScore = Math.max(bestScore, 300);
                aliases.forEach(function(alias) {
                    var comparableAlias = normalizeComparableTerm(alias);
                    if (!comparableAlias) return;
                    var aliasTokens = comparableAlias.split(' ');
                    if (comparableAlias === variant) bestScore = Math.max(bestScore, 950);
                    else if (comparableAlias.indexOf(variant + ' ') === 0) bestScore = Math.max(bestScore, 850);
                    else if (aliasTokens.indexOf(variant) !== -1) bestScore = Math.max(bestScore, 750);
                    else if (comparableAlias.indexOf(variant) !== -1) bestScore = Math.max(bestScore, 550);
                });
            });
            return bestScore;
        };
        var findCollectionMatches = function(term) {
            var variants = buildComparableVariants(term);
            if (!variants.length) return [];
            return collectionIndex.map(function(item, index) {
                return {
                    item: item,
                    index: index,
                    score: collectionMatchScore(item, variants)
                };
            }).filter(function(match) {
                return match.score > 0;
            }).sort(function(left, right) {
                if (right.score !== left.score) return right.score - left.score;
                var titleLengthDifference = String(left.item.title || '').length - String(right.item.title || '').length;
                return titleLengthDifference || left.index - right.index;
            }).slice(0, 8).map(function(match) {
                return match.item;
            });
        };
        var appendResultsHeading = function(resultsList, label, className) {
            if (!label) return;
            resultsList.append($('<li class="merlons-search-results-heading"></li>')
                .addClass(className || '')
                .attr({
                    'role': 'heading',
                    'aria-level': '2'
                })
                .append($('<span></span>').text(label)));
        };
        var appendCollectionMatches = function(resultsList, matches) {
            if (!matches.length) return;
            appendResultsHeading(resultsList, categoryResultsLabel, 'is-category-heading');
            $.each(matches, function(index, item) {
                var categoryTitle = item.title || item.handle || '';
                var categoryTitleNode = $('<span class="merlons-search-category-title"></span>');
                appendSearchHighlightedText(categoryTitleNode, categoryTitle, input.val());
                var collectionLink = $('<a class="merlons-search-category-link w-100"></a>')
                    .attr('href', item.url)
                    .append(categoryTitleNode)
                    .append('<svg class="merlons-search-category-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>');
                resultsList.append($('<li class="merlons-search-category-result"></li>').append(collectionLink));
            });
        };
        var headerSearchParent = $(this).parents('.header-search__parent');
        var Height = headerSearchParent.length ? (headerSearchParent.outerHeight() - $(this).outerHeight()) / 2 : 0;
        var offSetTop = input.position().top + input.outerHeight() + Height;
        var width = $(window).width();
        var offSetleft = $(this).offset().left * -1;
        if ($(this).find('.search-results__block').length == 0) {
            $('<div class="search-results__block"></div>').appendTo($(this).find('.search_autocomplete')).hide();
        }
        if (currentWidth > 767) {
            blockAutoComplete.css({'top': offSetTop, 'width': width, 'left': offSetleft });
            searchOverlay.css({'top': offSetTop, 'width': width, 'left': offSetleft});

        }else{
            blockAutoComplete.css({
                'top': '100%',
                'right': 'auto',
                'left': 0,
                'width': '100%',
                'max-width': '100%',
                'box-sizing': 'border-box'
            });
        }
        blockAutoComplete.removeClass('hidden').hide();

        $(this).find('.search-results__block').addClass(dataColor).append('<ul class="search-results"></ul>');

        searchForm.find('.btn-search__clear-text').off('click.novSearchClear').on('click.novSearchClear', function(event) {
            event.preventDefault();
            input.val('').removeAttr('data-old-term').trigger('change').focus();
        });

        searchForm.off('submit.novSearchNormalize').on('submit.novSearchNormalize', function(event) {
            var submittedTerm = normalizeSearchTerm(input.val(), true);
            input.val(submittedTerm);
            event.preventDefault();
            if (!submittedTerm) {
                input.focus();
                return;
            }
            cancelPendingAutocomplete();
            window.location.assign(buildCatalogURL(catalogAction, canonicalProductSearchTerm(submittedTerm)));
        });

        searchForm.off('click.novSearchCatalogRoute', '.search-see_all a').on('click.novSearchCatalogRoute', '.search-see_all a', function(event) {
            var catalogURL = $(this).attr('href');
            if (!catalogURL) return;
            event.preventDefault();
            cancelPendingAutocomplete();
            window.location.assign(catalogURL);
        });

        input.attr('autocomplete', 'off')
            .off('input.novSearchAutocomplete change.novSearchAutocomplete paste.novSearchAutocomplete')
            .on('paste.novSearchAutocomplete', function() {
                var pastedInput = this;
                window.setTimeout(function() {
                    var normalizedPastedTerm = normalizeSearchTerm(pastedInput.value, false);
                    if (pastedInput.value !== normalizedPastedTerm) pastedInput.value = normalizedPastedTerm;
                    $(pastedInput).removeAttr('data-old-term').trigger('input');
                }, 0);
            })
            .on('input.novSearchAutocomplete change.novSearchAutocomplete', function() {
            var term = normalizeSearchTerm($(this).val(), false);
            if ($(this).val() !== term) $(this).val(term);
            var queryTerm = normalizeSearchTerm(term, true);
            var previousTerm = $(this).attr('data-old-term');
            var shouldRequest = queryTerm.length > 0 && queryTerm !== previousTerm;
            if (term.length > 0) {
                searchForm.find('.btn-search__clear-text').removeClass('hide');
                searchForm.find('.search-header__content .icon').hide();
                searchForm.find('.search_overlay').addClass('act');
                searchForm.find('.search-header__placeholder').hide();
            } else {
                searchForm.find('.btn-search__clear-text').addClass('hide');
                searchForm.find('.search-header__content .icon').show();
                searchForm.find('.search-header__placeholder').show();
                $(this).closest('form.search-header-inline').find('.search-results__block').removeClass('is-active').hide();
                if (blockAutoComplete.find('.search_trend').length == 0) {
                    blockAutoComplete.stop(true, true).hide();
                }
            }
            var form = $(this).closest('form');
            var productQueryTerm = canonicalProductSearchTerm(queryTerm);
            var searchURL = buildSearchURL(searchAction, productQueryTerm);
            var resultsListBlock = form.find('.search-results__block');
            var resultsList = form.find('.search-results');
            if (shouldRequest) {
                $(this).attr('data-old-term', queryTerm);
                searchRequestToken += 1;
                var requestToken = searchRequestToken;
                if (searchDebounceTimer != null) {
                    window.clearTimeout(searchDebounceTimer);
                    searchDebounceTimer = null;
                }
                if (currentAjaxRequest != null) currentAjaxRequest.abort();
                searchDebounceTimer = window.setTimeout(function() {
                    searchDebounceTimer = null;
                    if (requestToken !== searchRequestToken || normalizeSearchTerm(input.val(), true) !== queryTerm) return;
                    var request = $.getJSON(searchURL + '&view=json');
                    currentAjaxRequest = request;
                    request.done(function(data) {
                        if (requestToken !== searchRequestToken || normalizeSearchTerm(input.val(), true) !== queryTerm) return;
                        resultsListBlock.removeClass('is-error');
                        resultsList.empty();
                        resultsListBlock.find('.search-see_all').remove();
                        var collectionMatches = findCollectionMatches(queryTerm);
                        appendCollectionMatches(resultsList, collectionMatches);
                        if(data.results_count == 0 && collectionMatches.length === 0) {
                            resultsListBlock.removeClass('is-active').hide();
                            if (blockAutoComplete.find('.search_trend').length == 0) {
                                if (isMobileHeaderSearch) {
                                    blockAutoComplete.stop(true, true).hide();
                                } else {
                                    blockAutoComplete.stop(true, true).slideUp(150);
                                }
                            }
                        } else {
                            if (data.results_count > 0) {
                                appendResultsHeading(resultsList, productResultsLabel, 'is-product-heading');
                            }
                            $.each(data.results, function(index, item) {
                                var resultItem = $('<li class="merlons-search-product-result"></li>');
                                var resultLayout = $('<div class="merlons-search-product-layout"></div>');
                                var mediaLink = $('<a class="merlons-search-product-media"></a>')
                                    .attr('href', item.url)
                                    .attr('aria-label', item.title || '');
                                var resultThumbnail = $('<div class="thumbnail"></div>');
                                if (item.thumbnail) {
                                    resultThumbnail.append($('<img class="w-100" />').attr({
                                        src: item.thumbnail,
                                        alt: item.title || ''
                                    }));
                                } else {
                                    resultThumbnail.append(
                                        $('<svg class="w-100 merlons-search-product-placeholder" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 5h16v14H4zM7 15l3-3 2 2 2-2 3 3M9 9h.01" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>')
                                    );
                                }
                                mediaLink.append(resultThumbnail);
                                var productInfo = $('<div class="product-info"></div>');
                                var titleNode = $('<div class="title"></div>');
                                appendSearchHighlightedText(titleNode, item.title, input.val());
                                var titleLink = $('<a class="merlons-search-product-title-link"></a>')
                                    .attr('href', item.url)
                                    .append(titleNode);
                                productInfo.append(titleLink);
                                if (item.sku) {
                                    var skuRow = $('<div class="merlons-search-sku"></div>');
                                    if (theme.strings.sku_label) {
                                        skuRow.append($('<span class="merlons-search-sku__label"></span>').text(theme.strings.sku_label + ':'));
                                    }
                                    var skuCopyLabel = theme.strings.copy_sku || theme.strings.sku_label || 'SKU';
                                    var skuValue = $('<span class="merlons-search-sku__value" role="button" tabindex="0" data-merlons-copy-sku></span>')
                                        .attr({
                                            title: skuCopyLabel,
                                            'aria-label': skuCopyLabel + ': ' + item.sku,
                                            'data-copy-success': theme.strings.sku_copied || '',
                                            'data-copy-error': theme.strings.sku_copy_failed || '',
                                            'data-merlons-copy-on-contextmenu': 'false'
                                        });
                                    appendSearchHighlightedText(skuValue, item.sku, input.val());
                                    skuRow.append(skuValue);
                                    productInfo.append(skuRow);
                                }
                                var detailsLink = $('<a class="merlons-search-product-details-link"></a>')
                                    .attr('href', item.url)
                                    .attr('aria-label', item.title || '')
                                    .append($('<div class="price price-st"></div>').text(item.price));
                                var statusRow = $('<div class="merlons-search-status-row"></div>');
                                if (typeof item.available === 'boolean') {
                                    var stockStatus = $('<div class="merlons-search-stock-status"></div>')
                                        .addClass(item.available ? 'is-in-stock' : 'is-out-of-stock')
                                        .text(item.available ? theme.strings.in_stock : theme.strings.out_of_stock);
                                    statusRow.append(stockStatus);
                                }
                                if (item.on_sale && item.sale_badge) {
                                    statusRow.append($('<span class="merlons-search-sale-badge"></span>').text(item.sale_badge));
                                }
                                if (statusRow.children().length) {
                                    detailsLink.append(statusRow);
                                }
                                productInfo.append(detailsLink);
                                resultLayout.append(mediaLink, productInfo);
                                resultItem.append(resultLayout);
                                resultsList.append(resultItem);
                            });
                            if(data.results_count > 4) {
                                var seeAllLink = $('<a class="see_all btn btn-secondary"></a>')
                                    .attr('href', buildCatalogURL(catalogAction, productQueryTerm))
                                    .append($('<span></span>').text(theme.strings.results_all))
                                    .append(document.createTextNode(' (' + data.results_count + ')'));
                                resultsList.after($('<div class="search-see_all"></div>').append(seeAllLink));
                            }
                            resultsListBlock.addClass('is-active');
                            if (isMobileHeaderSearch) {
                                resultsListBlock.stop(true, true).show();
                            } else {
                                resultsListBlock.fadeIn(200);
                            }
                            if (searchCanvas.length == 0) {
                                if (isMobileHeaderSearch) {
                                    blockAutoComplete.stop(true, true).show();
                                } else {
                                    blockAutoComplete.stop(true, true).slideDown(200);
                                }
                            }
                        }
                    }).fail(function(xhr, textStatus, errorThrown) {
                        if (textStatus === 'abort' || (xhr && xhr.statusText === 'abort')) return;
                        if (requestToken !== searchRequestToken || normalizeSearchTerm(input.val(), true) !== queryTerm) return;
                        $(input).removeAttr('data-old-term');
                        resultsList.empty();
                        resultsListBlock.find('.search-see_all').remove();
                        resultsListBlock.removeClass('is-active').addClass('is-error').hide();
                        if (blockAutoComplete.find('.search_trend').length == 0) {
                            blockAutoComplete.stop(true, true).hide();
                        } else if (isMobileHeaderSearch) {
                            blockAutoComplete.stop(true, true).show();
                        } else {
                            blockAutoComplete.stop(true, true).slideDown(150);
                        }
                        if (errorThrown) console.error('[Merlons search autocomplete]', errorThrown);
                    }).always(function() {
                        if (currentAjaxRequest === request) currentAjaxRequest = null;
                    });
                }, 180);
            } else if (queryTerm.length === 0) {
                searchRequestToken += 1;
                if (searchDebounceTimer != null) {
                    window.clearTimeout(searchDebounceTimer);
                    searchDebounceTimer = null;
                }
                $(this).removeAttr('data-old-term');
                if (currentAjaxRequest != null) {
                    currentAjaxRequest.abort();
                    currentAjaxRequest = null;
                }
                resultsList.empty();
                resultsListBlock.removeClass('is-active is-error').hide();
                if (blockAutoComplete.find('.search_trend').length > 0) {
                    if (isMobileHeaderSearch) {
                        blockAutoComplete.stop(true, true).show();
                    } else {
                        blockAutoComplete.stop(true, true).slideDown(150);
                    }
                } else {
                    blockAutoComplete.stop(true, true).hide();
                }
            }
            });
    });
};
novtheme.goToTop = function() {
    var $progress = $('#_desktop_back_top').find('.progress');
    var radius = 21;
    var circumference = 2 * Math.PI * radius;

    $progress.css({
    'stroke-dasharray': circumference,
    'stroke-dashoffset': circumference
    });

    function updateScrollButton() {
        var scrollTop = $(window).scrollTop();
        var docHeight = Math.max($(document).height() - $(window).height(), 1);
        var scrollPercent = Math.min(Math.max(scrollTop / docHeight, 0), 1);
        var offset = circumference * (1 - scrollPercent);

        $progress.css('stroke-dashoffset', offset);

        if (scrollTop >= 500) {
            $('#_desktop_back_top').fadeIn(500);
        } else {
            $('#_desktop_back_top').fadeOut(200);
        }
    }
    $(window).on('scroll', updateScrollButton);

    $(window).on('load', function () {
        updateScrollButton();
    });

    $('#_desktop_back_top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 500);
    });
};
novtheme.PopupNewletter = function() {
    var popupSubscribe = $("#popup-subscribe");
    var date = new Date();
    var minutes = 60;
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    if ($.cookie('popupNewLetterStatus') != 'closed' && body.outerWidth() > 768) {
        popupSubscribe.modal({
            show: !0
        });
    }
    if ($.cookie('popupNewLetterStatus') != 'closed' && popupSubscribe.data('sm') == true && responsive_mobile) {
        popupSubscribe.modal({
            show: !0
        });
    }
    $('input.no-view').change(function() {
        if ($('input.no-view').prop("checked") == 1) {
            $.cookie("popupNewLetterStatus", "closed", {
                'expires': date,
                'path': '/'
            })
        } else {
            $.cookie("popupNewLetterStatus", "", {
                'expires': date,
                'path': '/'
            })
        }
    })
    if (popupSubscribe.hasClass('promotion')) {
        popupSubscribe.click(function(){
            $.cookie("popupNewLetterStatus", "closed", {
                'expires': date,
                'path': '/'
            })
        })
    }
};
novtheme.MenuSidebar = function() {
    $('.categories__sidebar .hasSubCategory a').each(function(index) {
        if ($(this).hasClass('active')) {
            $(this).parent().children('.collapse').collapse('show');
        }
    })
};
novtheme.Nov_iframe_video = function() {
    var $videoSrc,
        modalVideo = $('#ModalVideo'),
        video = $('#video');
    $('.icon_play').click(function() {
        $videoSrc = $(this).data( "src" );
    });
    modalVideo.on('shown.bs.modal', function (e) {
        modalVideo.find('.embed-responsive').html('<iframe class="embed-responsive-item" src="'+ $videoSrc +'" id="video" allowfullscreen></iframe>');
    })
    modalVideo.on('hide.bs.modal', function (e) {
        modalVideo.find('iframe').remove();
    })
    $('.btn-video__play').each(function(){
        var id = $(this).data('id');
        $(this).click(function(){
            $(this).fadeOut();
            $('.bg-video__cover[data-id="'+ id +'"], .block-text[data-id="'+ id +'"]').fadeOut();
            $('video[data-id="'+ id +'"]').trigger('play');
        })
        if (currentWidth < 992) {
            $('video[data-id="'+ id +'"]').trigger('play');
        }
    })
    $('video').each(function(){
        var alt = $(this).data('alt');
        if (alt && alt.length) {
            $(this).find('img').attr('alt', alt);
        }
    })
};
novtheme.MegaMenuSlider = function() {
    var megaSlider = $(".megamenu-product-slider");
    var autoplay = megaSlider.data("autoplay");
    megaSlider.slick({
        autoplay: autoplay,
        autoplaySpeed: 2000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        rtl: rtl
    });
};
novtheme.LoadmoreByButton = function(){
    var moreButon =  $('.btn_loadmore');
    var data = $(moreButon).parents('.grid--view-items');
    $(moreButon).each(function(){
        var btnHandle = $(this).attr('btn-handle');
        var nextUrl = $(this).attr("link");
        body.on('click', '.'+btnHandle+'', function(){
            $.ajax({
                url: nextUrl,
                type: 'GET',
                dataType: 'html',
                beforeSend: function() {
                    $('.'+btnHandle).addClass('loading');
                }
            }).done(function(data) {
                $('.product__loadmore-'+btnHandle).append($(data).find('.product__loadmore-'+btnHandle).html());
                var m = $('.pagination__bar'+btnHandle+'').data('max');
                var dataitem = $('.product__loadmore-'+btnHandle);
                AnimateLoadmore(dataitem);
                if ($('.AirReviews-Widget').length > 0) {
                    window.avadaAirReviewRerender();
                }
                nextUrl = $(data).find('.btn_loadmore').attr("link");
                var n = $('.product__loadmore-'+btnHandle).find('.item').length;
                $('.pagination__count'+btnHandle+' .count').text(n);
                $('.pagination__bar'+btnHandle+' .progress').css('width',  n/m*100 + '%');
                if (n < m) {
                    $('.'+btnHandle).removeClass('loading');
                } else {
                    $('.'+btnHandle).remove();
                }
            });
        });
    });
    function AnimateLoadmore (el) {
        var xxl = el.data('xxl'),
            xl = el.data('xl'),
            lg = el.data('lg'),
            md = el.data('md'),
            sm = el.data('sm'),
            xs = el.data('xs');
        el.find('.item').each(function () {
            var index = $(this).index() + 1;
            var n;
            if ($(document).width() > 1439) {
                n = xxl;
            } else if ($(document).width() > 1199) {
                n = xl;
            } else if ($(document).width() > 991) {
                n = lg;
            } else if ($(document).width() > 767) {
                n = lg;
            } else if ($(document).width() > 575) {
                n = sm;
            } else {
                n = xs;
            }
            var modulo = Math.round(index % n * 0.3);
            $(this).attr('data-wow-duration', modulo+'s');
            if (index % n == 0) {
                var modulo0 = index % n + n *0.3;
                $(this).attr('data-wow-duration', modulo0+'s');
            } 
        });
    }
};
novtheme.Mainmenu = function() {
    $('.site-nav--btn').off('click.merlonsMainmenu keydown.merlonsMainmenu').on('click.merlonsMainmenu keydown.merlonsMainmenu', function(event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (event.type === 'keydown') event.preventDefault();
        if ($(window).width() > 1199) {
            $(this).toggleClass('act');
        } else {
            if (novtheme.mobileMenu && typeof novtheme.mobileMenu.toggle === 'function') {
                novtheme.mobileMenu.toggle($(this));
            } else {
                var mobileMenu = $('#mobile_menu');
                $('.site-nav--btn, #show-megamenu').toggleClass('act', !mobileMenu.hasClass('act')).attr('aria-expanded', !mobileMenu.hasClass('act') ? 'true' : 'false');
                sidebarOverlay.add(mobileMenu).toggleClass('act', !mobileMenu.hasClass('act'));
            }
            $('.mobile-btn_search, #mobile_search, .search_overlay ').removeClass('act');
            $('.mobile-btn_search')
                .attr('aria-expanded', 'false')
                .each(function() {
                    var searchLabel = $(this).data('search-label');
                    if (searchLabel) $(this).attr('aria-label', searchLabel);
                });
        }
    });
};
novtheme.CollectionPage = function() {
    var gridlistToggle = $('.gridlist-toggle'),
        collectionContent = $('.collection__product-content'),
        item = gridlistToggle.find('a'),
        defaultGrid = collectionContent.attr('data-default-grid') || collectionContent.attr('data-grid');
    if (gridlistToggle.length) {
        if (localStorage.getItem('view_collection')) {
            item.removeClass('active');
            if (gridlistToggle.find('[data-type="'+ localStorage.getItem('view_collection') +'"]').length > 0) {
                gridlistToggle.find('[data-type="'+ localStorage.getItem('view_collection') +'"]').addClass('active');
                collectionContent.attr('data-grid', localStorage.getItem('view_collection'));
            } else {
                gridlistToggle.find('a:first-child').addClass('active');
                collectionContent.attr('data-grid', gridlistToggle.find('a:first-child').data('type'));
            }
        }
        item.click(function(e) {
            e.preventDefault();
            var typeview = $(this).data('type');
            if (!$(this).hasClass('active')) {
                collectionContent.attr('data-grid', typeview);
                item.removeClass('active');
                $(this).addClass('active');
            }
            localStorage.setItem('view_collection', collectionContent.attr('data-grid'));
        });
    }
    if($(window).width() <768 ) {
        collectionContent.attr('data-grid', 'grid-2');
        item.removeClass('active');
        gridlistToggle.find('#grid-2').addClass('active');
    } else if($(window).width() <992 ) {
        collectionContent.attr('data-grid', 'grid-3');
        item.removeClass('active');
        gridlistToggle.find('#grid-3').addClass('active');
    } else if (!gridlistToggle.length && defaultGrid) {
        collectionContent.attr('data-grid', defaultGrid);
    }
    // Click filter sort by
    var sortBy = $('[name="sort_by"]'),
        sortbyFilter = $('[data-sortby-filter]'),
        sortbyItem = sortbyFilter.find('[data-sortby-item]'),
        sortChooseLabel = sortbyFilter.find('.sort-by__label').first().attr('data-choose-label') || $.trim(sortbyFilter.find('.sort-by__label').first().text());
    var params = new URLSearchParams(window.location.search);

    function syncMerlonsSpecialCollectionState() {
        var root = document.getElementById('main-collection-filters'),
            currentParams = new URLSearchParams(window.location.search),
            mode = currentParams.get('merlons_sort'),
            isSpecial = !!root && root.getAttribute('data-merlons-collection-handle') === 'all'
                && (mode === 'discount' || mode === 'liquidation');
        document.documentElement.classList.toggle('merlons-special-collection', isSpecial);
        if (isSpecial) document.documentElement.setAttribute('data-merlons-special-collection', mode);
        else document.documentElement.removeAttribute('data-merlons-special-collection');
        if (!root) return;
        if (!isSpecial) root.removeAttribute('data-merlons-special-loading');
        var labelAttribute = mode === 'combined'
            ? 'data-merlons-sale-prices-label'
            : mode === 'discount'
                ? 'data-merlons-discount-label'
                : 'data-merlons-liquidation-label';
        var label = isSpecial
            ? root.getAttribute(labelAttribute)
            : root.getAttribute('data-merlons-collection-label');
        var breadcrumbs = document.getElementById('NovBreadcrumbs');
        if (!breadcrumbs || !label) return;
        var heading = breadcrumbs.querySelector('.headingBreacrumb'),
            current = breadcrumbs.querySelector('[aria-current="page"]')
                || breadcrumbs.querySelector('.breadcrumb .list-inline-item:last-child .item-breacrumb');
        if (heading) heading.textContent = label;
        if (current) current.textContent = label;
    }
    window.merlonsSyncSpecialCollectionState = syncMerlonsSpecialCollectionState;

    function syncCollectionSortUI() {
        syncMerlonsSpecialCollectionState();
        if (!sortbyFilter.length) return;
        var currentParams = new URLSearchParams(window.location.search),
            localSort = currentParams.get('merlons_sort'),
            nativeSort = currentParams.get('sort_by');
        var hasCustomSort = localSort === 'discount' || localSort === 'liquidation',
            hasOfferFilter = typeof window.merlonsGetSelectedOfferModes === 'function'
                && window.merlonsGetSelectedOfferModes(currentParams).length > 0;
        if (!hasCustomSort && !hasOfferFilter && typeof window.merlonsCancelCollectionLocalSort === 'function') {
            window.merlonsCancelCollectionLocalSort();
        }
        if (!localSort && !nativeSort) nativeSort = sortBy.first().val() || '';
        var selectedSortItem = hasCustomSort
            ? sortbyFilter.find('[data-merlons-sort="'+ localSort +'"]')
            : nativeSort ? sortbyFilter.find('[data-value="'+ nativeSort +'"]') : $();
        sortbyItem.removeClass('act');
        if (selectedSortItem.length) {
            sortbyFilter.find('.sort-by__label').text($.trim(selectedSortItem.first().text()));
            selectedSortItem.addClass('act');
        } else {
            sortbyFilter.find('.sort-by__label').text(sortChooseLabel);
        }
        sortBy.val(hasCustomSort ? '' : nativeSort);
        sortbyItem.attr('aria-checked', 'false');
        if (selectedSortItem.length) selectedSortItem.attr('aria-checked', 'true');
    }
    window.merlonsSyncCollectionSortUI = syncCollectionSortUI;
    syncCollectionSortUI();
    $(window).off('popstate.merlonsCollectionSort').on('popstate.merlonsCollectionSort', syncCollectionSortUI);

    function closeSortDropdown() {
        var title = sortbyFilter.find('.nov-accordion__title');
        title.removeClass('act').attr('aria-expanded', 'false');
        title.parent().removeClass('act');
        sortbyFilter.removeClass('act');
        sortbyFilter.find('.nov-accordion__content').stop(true, true).slideUp(150);
    }

    sortbyItem.off('click.merlonsCollectionSort').on('click.merlonsCollectionSort', function (event) {
        event.preventDefault();
        var valuesort = $(this).data('value');
        var newtext = $(this).text();
        var localSort = $(this).data('merlons-sort');
        sortbyItem.removeClass('act');
        $(this).addClass('act');
        sortbyFilter.find('.sort-by__label').text($.trim(newtext));
        closeSortDropdown();
        params = new URLSearchParams(window.location.search);
        if (localSort) {
            params.delete('merlons_offer');
            params.set('merlons_sort', localSort);
            params.delete('page');
            params.delete('sort_by');
            var localSearch = params.toString();
            if (localSearch !== window.location.search.slice(1)) {
                window.history.pushState({ searchParams: localSearch }, '', window.location.pathname + (localSearch ? '?' + localSearch : ''));
            }
            syncCollectionSortUI();
            var query = $.trim(params.get('q') || '');
            var collectionRoot = document.getElementById('main-collection-filters'),
                isSearchResultsPage = !!collectionRoot && collectionRoot.classList.contains('page-search');
            if (query && isSearchResultsPage && typeof window.merlonsApplyCollectionLocalSort === 'function') {
                window.merlonsApplyCollectionLocalSort(localSort);
            } else if (query && typeof window.merlonsApplyCollectionSearch === 'function') {
                window.merlonsApplyCollectionSearch(query);
            } else if (typeof window.merlonsApplyCollectionLocalSort === 'function') {
                window.merlonsApplyCollectionLocalSort(localSort);
            }
            return;
        }
        params.delete('merlons_sort');
        params.delete('page');
        params.set('sort_by', valuesort);
        if (typeof window.merlonsCancelCollectionLocalSort === 'function') window.merlonsCancelCollectionLocalSort();
        sortBy.val(valuesort);
        const form = document.querySelector('collection-filter-product');
        if (form && typeof form.onSubmitForm === 'function') {
            form.onSubmitForm(params.toString(), event);
            syncCollectionSortUI();
        } else {
            window.location.assign(window.location.pathname + '?' + params.toString());
        }
    });
    $('.collection__category-branch-toggle').off('click.merlonsCategoryBranch').on('click.merlonsCategoryBranch', function () {
        var button = $(this),
            expanded = button.attr('aria-expanded') === 'true',
            targetId = button.attr('aria-controls'),
            target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;
        target.hidden = expanded;
        button.attr('aria-expanded', expanded ? 'false' : 'true');
        button.attr('aria-label', expanded ? button.attr('data-expand-label') : button.attr('data-collapse-label'));
    });
};

/* Shopify has native price sorts but no percentage-discount sort. Merlons uses
 * a layout-free alternate view for the two custom modes. Collection arrays can
 * return 250 items per page, while Shopify caps search.results at 50. */
function merlonsCollectionSortBatchSize(grid) {
    var root = grid && grid.closest('#main-collection-filters');
    return root && root.classList.contains('page-search') ? 50 : 250;
}
var merlonsCollectionSortCache = { key: '', promise: null, items: null, controller: null, completedAt: 0, handoffConsumed: false };
var merlonsCollectionSortHandoffTTL = 2000;
var merlonsCollectionSortRequest = 0;

function merlonsToggleOfferScanControls(active) {
    document.querySelectorAll(
        '#main-collection-filters .collection__btn-loadmore, ' +
        '#main-collection-filters .scroll__infinityfilter, ' +
        '#main-collection-filters .paging, ' +
        '#main-collection-filters .nov-pagination'
    ).forEach(function (control) {
        if (active) {
            if (!control.hasAttribute('hidden')) {
                control.setAttribute('data-merlons-offer-scan-restore', 'true');
            }
            control.hidden = true;
            control.setAttribute('aria-hidden', 'true');
        } else if (control.hasAttribute('data-merlons-offer-scan-restore')) {
            control.hidden = false;
            control.removeAttribute('aria-hidden');
            control.removeAttribute('data-merlons-offer-scan-restore');
        }
    });
}

window.merlonsCancelCollectionLocalSort = function (preserveSharedScan) {
    merlonsCollectionSortRequest += 1;
    if (!preserveSharedScan) {
        var controller = merlonsCollectionSortCache.controller;
        merlonsCollectionSortCache = { key: '', promise: null, items: null, controller: null, completedAt: 0, handoffConsumed: false };
        if (controller) controller.abort();
    }
    var container = document.getElementById('CollectionProductContainer');
    if (container) container.removeAttribute('aria-busy');
    $('[data-sortby-filter]').removeClass('is-loading');
    if (!preserveSharedScan) merlonsToggleOfferScanControls(false);
};

window.merlonsGetSelectedOfferModes = function (params) {
    var source = params && typeof params.getAll === 'function'
        ? params
        : new URLSearchParams(params || window.location.search);
    var validModes = { discount: true, liquidation: true };
    var selectedModes = [];
    var seen = {};
    source.getAll('merlons_offer').forEach(function (mode) {
        if (validModes[mode] && !seen[mode]) {
            seen[mode] = true;
            selectedModes.push(mode);
        }
    });
    return selectedModes;
};

function merlonsNormalizeOfferModes(offerModes) {
    var selectedModes = [];
    var seen = {};
    (Array.isArray(offerModes) ? offerModes : []).forEach(function (mode) {
        if ((mode === 'discount' || mode === 'liquidation') && !seen[mode]) {
            seen[mode] = true;
            selectedModes.push(mode);
        }
    });
    return selectedModes;
}

function merlonsCollectionSortPath(grid) {
    return grid && grid.getAttribute('data-filter-path') || window.location.pathname;
}

function merlonsCollectionSortSources(grid) {
    var root = grid && grid.closest('#main-collection-filters');
    var sources = [];
    if (typeof window.merlonsGetCollectionCategorySources === 'function') {
        sources = window.merlonsGetCollectionCategorySources() || [];
    } else if (root) {
        var sourceNode = root.querySelector('[data-merlons-category-sources]');
        if (sourceNode) {
            try {
                sources = JSON.parse(sourceNode.textContent || '[]');
            } catch (error) {
                console.error('[Merlons category hierarchy]', error);
            }
        }
    }
    if (!Array.isArray(sources) || !sources.length) {
        sources = [{ url: merlonsCollectionSortPath(grid) }];
    }
    var seen = {};
    var normalizedSources = sources.map(function (source) {
        var value = source && typeof source === 'object' ? source.url : source;
        var handle = source && typeof source === 'object' ? String(source.handle || '').trim().toLowerCase() : '';
        var url = merlonsCollectionUrl(value);
        if (!url || seen[url.pathname]) return null;
        seen[url.pathname] = true;
        return { handle: handle, url: url.pathname };
    }).filter(Boolean);

    /* For a broad parent, fetching every descendant independently creates a
     * request fan-out and downloads duplicate cards. Scan the localized all-
     * products endpoint once, then keep only products whose Shopify collection
     * memberships intersect the inclusive hierarchy. Smaller branches retain
     * the cheaper per-collection strategy. */
    if (root && normalizedSources.length > 6) {
        var allProductsPath = root.getAttribute('data-merlons-all-products-path');
        var allProductsUrl = merlonsCollectionUrl(allProductsPath);
        var scopeHandles = normalizedSources.map(function (source) { return source.handle; }).filter(Boolean);
        if (allProductsUrl && scopeHandles.length) {
            scopeHandles.sort();
            return [{
                handle: 'all',
                url: allProductsUrl.pathname,
                scopeHandles: scopeHandles,
                scopeHandleSet: new Set(scopeHandles),
                scopeKey: scopeHandles.join('|')
            }];
        }
    }
    return normalizedSources;
}

function merlonsCollectionSortKey(grid) {
    var params = new URLSearchParams(window.location.search);
    params.delete('merlons_sort');
    params.delete('merlons_offer');
    params.delete('page');
    params.delete('section_id');
    params.delete('view');
    params.sort();
    return merlonsCollectionSortSources(grid).map(function (source) {
        return source.url + (source.scopeKey ? '#' + source.scopeKey : '');
    }).join('|') + '?' + params.toString();
}

function merlonsFetchAllCollectionItems(grid) {
    var key = merlonsCollectionSortKey(grid);
    if (merlonsCollectionSortCache.key === key && merlonsCollectionSortCache.items) {
        var handoffAge = Date.now() - merlonsCollectionSortCache.completedAt;
        if (!merlonsCollectionSortCache.handoffConsumed && handoffAge >= 0 && handoffAge <= merlonsCollectionSortHandoffTTL) {
            merlonsCollectionSortCache.handoffConsumed = true;
            return Promise.resolve(merlonsCollectionSortCache.items);
        }
        merlonsCollectionSortCache = { key: '', promise: null, items: null, controller: null, completedAt: 0, handoffConsumed: false };
    }
    if (merlonsCollectionSortCache.key === key && merlonsCollectionSortCache.promise) {
        return merlonsCollectionSortCache.promise;
    }

    if (merlonsCollectionSortCache.controller) merlonsCollectionSortCache.controller.abort();

    var sources = merlonsCollectionSortSources(grid);
    var baseParams = new URLSearchParams(window.location.search);
    baseParams.delete('merlons_sort');
    baseParams.delete('merlons_offer');
    baseParams.delete('page');
    baseParams.delete('section_id');
    var initialTasks = sources.map(function (_source, sourceIndex) {
        return { sourceIndex: sourceIndex, pageNumber: 1 };
    });
    var tasks = [];
    var pageItems = sources.map(function () { return []; });
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var cacheEntry = { key: key, promise: null, items: null, controller: controller };

    function recordFromItem(item, source) {
        var price = Number(item.getAttribute('data-merlons-price') || 0);
        var compareAtPrice = Number(item.getAttribute('data-merlons-compare-at-price') || 0);
        var discountRatio = compareAtPrice > price && compareAtPrice > 0 ? (compareAtPrice - price) / compareAtPrice : 0;
        var discountOffer = item.getAttribute('data-merlons-offer-discount');
        var liquidationOffer = item.getAttribute('data-merlons-offer-liquidation');
        if (source.scopeHandleSet) {
            var collectionHandles = String(item.getAttribute('data-merlons-collection-handles') || '').split('|').filter(Boolean);
            if (!collectionHandles.some(function (handle) { return source.scopeHandleSet.has(handle); })) return null;
        }
        return {
            id: item.getAttribute('data-product-id') || '',
            markup: item.outerHTML,
            discountRatio: discountRatio,
            isDiscounted: discountRatio > 0 && discountRatio <= 0.44,
            isLiquidation: discountRatio > 0.44,
            offerDiscount: discountOffer === null ? discountRatio > 0 && discountRatio <= 0.44 : discountOffer === 'true' || discountOffer === '1',
            offerLiquidation: liquidationOffer === null ? discountRatio > 0.44 : liquidationOffer === 'true' || liquidationOffer === '1'
        };
    }

    function fetchPage(task) {
        var pageNumber = task.pageNumber;
        var source = sources[task.sourceIndex];
        var pageParams = new URLSearchParams(baseParams);
        pageParams.set('view', source.scopeHandleSet ? 'merlons-sort-data-scoped' : 'merlons-sort-data');
        pageParams.set('page', pageNumber);
        var url = source.url + '?' + pageParams.toString();
        var fetchOptions = {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            cache: 'no-store'
        };
        if (controller) fetchOptions.signal = controller.signal;
        return fetch(url, fetchOptions)
            .then(function (response) {
                if (!response.ok) throw new Error('Collection page request failed: ' + response.status);
                return response.text();
            })
            .then(function (html) {
                var parsed = new DOMParser().parseFromString(html, 'text/html');
                var sourceGrid = parsed.querySelector('#product-grid');
                if (!sourceGrid) throw new Error('Collection product grid is missing on page ' + pageNumber);
                pageItems[task.sourceIndex][pageNumber - 1] = Array.prototype.map.call(
                    sourceGrid.querySelectorAll('.product--item'),
                    function (item) { return recordFromItem(item, source); }
                ).filter(Boolean);
                if (pageNumber === 1) {
                    var totalPages = Math.min(1000, Math.max(0, Number(sourceGrid.getAttribute('data-total-pages') || 0)));
                    for (var nextPage = 2; nextPage <= totalPages; nextPage += 1) {
                        tasks.push({ sourceIndex: task.sourceIndex, pageNumber: nextPage });
                    }
                }
            });
    }

    function fetchNextPage() {
        var task = tasks.shift();
        if (!task) return Promise.resolve();
        return fetchPage(task).then(fetchNextPage);
    }

    merlonsCollectionSortCache = cacheEntry;
    cacheEntry.promise = Promise.all(initialTasks.map(fetchPage)).then(function () {
            var workerCount = Math.min(6, tasks.length);
            var workers = [];
            for (var worker = 0; worker < workerCount; worker += 1) workers.push(fetchNextPage());
            return Promise.all(workers);
        }).then(function () {
            var seen = {};
            var completeItems = [];
            pageItems.forEach(function (sourcePages) {
                sourcePages.forEach(function (items) {
                    (items || []).forEach(function (item) {
                        var uniqueKey = item.id || item.markup;
                        if (!seen[uniqueKey]) {
                            seen[uniqueKey] = true;
                            completeItems.push(item);
                        }
                    });
                });
            });
            cacheEntry.items = completeItems;
            cacheEntry.completedAt = Date.now();
            cacheEntry.handoffConsumed = false;
            cacheEntry.promise = null;
            return completeItems;
        }).catch(function (error) {
            if (merlonsCollectionSortCache === cacheEntry) {
                merlonsCollectionSortCache = { key: '', promise: null, items: null, controller: null, completedAt: 0, handoffConsumed: false };
            }
            throw error;
        });
    return cacheEntry.promise;
}

window.merlonsPrefetchCollectionLocalSort = function (grid) {
    var targetGrid = grid || document.querySelector('#product-grid');
    if (!targetGrid) return Promise.resolve([]);
    return merlonsFetchAllCollectionItems(targetGrid);
};

function merlonsExpireCompletedSortHandoff() {
    if (!merlonsCollectionSortCache.promise && merlonsCollectionSortCache.items) {
        merlonsCollectionSortCache.items = null;
        merlonsCollectionSortCache.completedAt = 0;
        merlonsCollectionSortCache.handoffConsumed = true;
    }
}
window.addEventListener('pageshow', function (event) {
    if (event.persisted) merlonsExpireCompletedSortHandoff();
});
document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') merlonsExpireCompletedSortHandoff();
});

function merlonsRebindCollectionCards(grid) {
    var $grid = $(grid);
    $grid.find('.btn-quick-add').off('click.merlonsCollectionSort').on('click.merlonsCollectionSort', function () {
        var $item = $(this).closest('.item-product');
        $('.item-product__popup--variant').removeClass('act');
        $item.find('.item-product__popup--variant').first().addClass('act');
        $item.find('.thumbnail-container').first().addClass('popup-act');
    });
    $grid.find('.btn-close-quick-add').off('click.merlonsCollectionSort').on('click.merlonsCollectionSort', function () {
        var $item = $(this).closest('.item-product');
        $(this).parent().removeClass('act');
        $item.find('.thumbnail-container').first().removeClass('popup-act');
    });
    if (window.lazySizes && window.lazySizes.loader) {
        var preloadTop = -400;
        var preloadBottom = window.innerHeight + 900;
        grid.querySelectorAll('.lazyload').forEach(function (image) {
            var bounds = image.getBoundingClientRect();
            if (bounds.bottom >= preloadTop && bounds.top <= preloadBottom) {
                window.lazySizes.loader.unveil(image);
            }
        });
    }
}
window.merlonsRebindCollectionCards = merlonsRebindCollectionCards;

window.merlonsApplyCollectionLocalSort = function (mode, offerModes) {
    var referenceParams = new URLSearchParams(window.location.search);
    if (referenceParams.get('q') && window.MerlonsFilterIndex && window.MerlonsFilterIndex.hasReferences(referenceParams)) {
        return window.merlonsApplyCollectionSearch(referenceParams.get('q'));
    }
    var grid = document.querySelector('#product-grid');
    var selectedOfferModes = merlonsNormalizeOfferModes(offerModes);
    var hasOfferModes = selectedOfferModes.length > 0;
    var hasLegacySort = !hasOfferModes && (mode === 'discount' || mode === 'liquidation');
    if (!grid || (!hasOfferModes && !hasLegacySort)) return Promise.resolve();
    if (typeof window.merlonsCancelCollectionInfiniteScroll === 'function') {
        window.merlonsCancelCollectionInfiniteScroll();
    }
    if (typeof window.merlonsCancelCategoryHierarchy === 'function') {
        window.merlonsCancelCategoryHierarchy();
    }
    var requestId = ++merlonsCollectionSortRequest;
    var container = document.getElementById('CollectionProductContainer');
    if (container) container.setAttribute('aria-busy', 'true');
    $('[data-sortby-filter]').addClass('is-loading');
    if (hasOfferModes) merlonsToggleOfferScanControls(true);

    /* Give offer filters an immediate, already-correct first-page preview while
     * the complete collection scan is resolved. The authoritative result below
     * still replaces this preview, so no matching product is omitted. */
    if (hasOfferModes) {
        Array.prototype.forEach.call(grid.querySelectorAll('.product--item'), function (item) {
            var price = Number(item.getAttribute('data-merlons-price') || 0);
            var compareAtPrice = Number(item.getAttribute('data-merlons-compare-at-price') || 0);
            var discountRatio = compareAtPrice > price && compareAtPrice > 0
                ? (compareAtPrice - price) / compareAtPrice
                : 0;
            var discountValue = item.getAttribute('data-merlons-offer-discount');
            var liquidationValue = item.getAttribute('data-merlons-offer-liquidation');
            var isDiscount = discountValue === null
                ? discountRatio > 0 && discountRatio <= 0.44
                : discountValue === 'true' || discountValue === '1';
            var isLiquidation = liquidationValue === null
                ? discountRatio > 0.44
                : liquidationValue === 'true' || liquidationValue === '1';
            var matches = (selectedOfferModes.indexOf('discount') !== -1 && isDiscount)
                || (selectedOfferModes.indexOf('liquidation') !== -1 && isLiquidation);
            item.hidden = !matches;
        });
    }

    return merlonsFetchAllCollectionItems(grid).then(function (allItems) {
        if (requestId !== merlonsCollectionSortRequest || document.querySelector('#product-grid') !== grid) return;
        var visibleItemKeys = {};
        var visibleItems = allItems.filter(function (item) {
            var matchesOffer = false;
            if (hasOfferModes) {
                matchesOffer = (selectedOfferModes.indexOf('discount') !== -1 && item.offerDiscount)
                    || (selectedOfferModes.indexOf('liquidation') !== -1 && item.offerLiquidation);
            } else {
                matchesOffer = mode === 'liquidation' ? item.isLiquidation : item.isDiscounted;
            }
            if (!matchesOffer) return false;
            var itemKey = item.id || item.markup;
            if (visibleItemKeys[itemKey]) return false;
            visibleItemKeys[itemKey] = true;
            return true;
        });
        if (hasLegacySort) visibleItems.sort(function (a, b) { return b.discountRatio - a.discountRatio; });
        return new Promise(function (resolve) {
            window.requestAnimationFrame(function () {
                if (requestId !== merlonsCollectionSortRequest || document.querySelector('#product-grid') !== grid) {
                    resolve();
                    return;
                }
                grid.innerHTML = visibleItems.map(function (item) { return item.markup; }).join('');
                if (!visibleItems.length) {
                    var collectionRoot = document.getElementById('main-collection-filters');
                    var emptyLabel = collectionRoot ? collectionRoot.getAttribute('data-merlons-empty-label') : '';
                    var emptyState = document.createElement('div');
                    var emptyHeading = document.createElement('h2');
                    emptyState.className = 'merlons-special-collection-empty col-12 text-center';
                    emptyHeading.className = 'mb-0';
                    emptyHeading.textContent = emptyLabel || '';
                    emptyState.appendChild(emptyHeading);
                    grid.appendChild(emptyState);
                }
                grid.removeAttribute('data-next-url');
                grid.setAttribute('data-current-page', '1');
                grid.setAttribute('data-total-pages', '1');
                grid.setAttribute('data-total-products', String(visibleItems.length));
                $('.pagination__count .count').text(visibleItems.length);
                $('.pagination__count .total').text(visibleItems.length);
                $('.pagination__bar').attr('data-max', visibleItems.length);
                $('.pagination__bar .progress').css('width', '100%');
                $('.collection__btn-loadmore, .scroll__infinityfilter, .paging, .nov-pagination').remove();
                merlonsRebindCollectionCards(grid);
                resolve();
            });
        });
    }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (requestId !== merlonsCollectionSortRequest) return;
        merlonsToggleOfferScanControls(false);
        console.error('[Merlons collection sorter]', error);
        var fallbackParams = new URLSearchParams(window.location.search);
        fallbackParams.delete('merlons_sort');
        fallbackParams.delete('merlons_offer');
        fallbackParams.delete('page');
        fallbackParams.delete('section_id');
        fallbackParams.delete('view');
        var fallbackSearch = fallbackParams.toString();
        var fallbackUrl = window.location.pathname + (fallbackSearch ? '?' + fallbackSearch : '');
        window.location.replace(fallbackUrl);
    }).finally(function () {
        if (requestId === merlonsCollectionSortRequest) {
            if (container) container.removeAttribute('aria-busy');
            $('[data-sortby-filter]').removeClass('is-loading');
            var collectionRoot = document.getElementById('main-collection-filters');
            if (collectionRoot) collectionRoot.removeAttribute('data-merlons-special-loading');
        }
    });
};
$(function () {
    var initialParams = new URLSearchParams(window.location.search),
        sort = initialParams.get('merlons_sort'),
        offerModes = window.merlonsGetSelectedOfferModes(initialParams),
        query = $.trim(initialParams.get('q') || ''),
        collectionRoot = document.getElementById('main-collection-filters'),
        isSearchResultsPage = !!collectionRoot && collectionRoot.classList.contains('page-search');
    if (!query || isSearchResultsPage) {
        if (offerModes.length) window.merlonsApplyCollectionLocalSort(null, offerModes);
        else if (sort === 'discount' || sort === 'liquidation') window.merlonsApplyCollectionLocalSort(sort);
    }
});
var merlonsCollectionInfiniteState = {
    observer: null,
    controller: null,
    fallbackRequest: null,
    fallbackGrid: null,
    generation: 0,
    inFlight: false,
    stateKey: '',
    grid: null,
    lastPage: 0,
    loadedUrls: new Set(),
    listenersBound: false
};

function merlonsCollectionUrl(value) {
    try {
        return new URL(value || window.location.href, window.location.href);
    } catch (error) {
        return null;
    }
}

function merlonsCollectionStateKey(value) {
    var url = merlonsCollectionUrl(value);
    if (!url) return '';
    ['page', 'section_id', 'view'].forEach(function (key) {
        url.searchParams.delete(key);
    });
    url.searchParams.sort();
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
}

function merlonsCollectionRequestKey(value) {
    var url = merlonsCollectionUrl(value);
    if (!url) return '';
    url.hash = '';
    url.searchParams.delete('section_id');
    url.searchParams.delete('view');
    url.searchParams.sort();
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
}

function merlonsCollectionInfiniteIsExcluded() {
    var params = new URLSearchParams(window.location.search);
    var query = (params.get('q') || '').replace(/\s+/g, ' ').trim();
    var localSort = params.get('merlons_sort');
    var offerModes = typeof window.merlonsGetSelectedOfferModes === 'function'
        ? window.merlonsGetSelectedOfferModes(params)
        : [];
    var collectionRoot = document.getElementById('main-collection-filters');
    var isSearchResultsPage = !!collectionRoot && collectionRoot.classList.contains('page-search');
    var hasCategoryHierarchy = !!collectionRoot
        && collectionRoot.getAttribute('data-merlons-hierarchy-active') === 'true';
    var referenceSearch = query && window.MerlonsFilterIndex && window.MerlonsFilterIndex.hasReferences(params);
    return Boolean(hasCategoryHierarchy || (query && !isSearchResultsPage) || referenceSearch || localSort === 'discount' || localSort === 'liquidation' || offerModes.length);
}

function merlonsCollectionInfiniteDisconnect() {
    if (merlonsCollectionInfiniteState.observer) {
        merlonsCollectionInfiniteState.observer.disconnect();
        merlonsCollectionInfiniteState.observer = null;
    }
}

function merlonsCollectionInfiniteClearBusy(root) {
    merlonsCollectionInfiniteState.inFlight = false;
    merlonsCollectionInfiniteState.controller = null;
    var container = document.getElementById('CollectionProductContainer');
    if (container) container.removeAttribute('aria-busy');
    if (root) root.classList.remove('is-loading');
}

function merlonsCollectionInfiniteStatus(root, type, count) {
    if (!root) return;
    var status = root.querySelector('[data-merlons-infinite-status]');
    if (!status) return;
    var label = root.getAttribute('data-' + type + '-label') || '';
    if (typeof count !== 'undefined') {
        label = label
            .replace(/\[count\]/g, String(count))
            .replace(/\{\{\s*count\s*\}\}/g, String(count));
    }
    status.textContent = label;
}

function merlonsCollectionInfiniteFail(root, error) {
    merlonsCollectionInfiniteDisconnect();
    merlonsCollectionInfiniteClearBusy(root);
    if (!root || !root.isConnected) return;
    root.classList.remove('is-complete');
    root.classList.add('is-error');
    merlonsCollectionInfiniteStatus(root, 'error');
    if (error) console.error('[Merlons infinite scroll]', error);
}

window.merlonsCancelCollectionInfiniteScroll = function () {
    merlonsCollectionInfiniteState.generation += 1;
    merlonsCollectionInfiniteDisconnect();
    if (merlonsCollectionInfiniteState.controller) {
        merlonsCollectionInfiniteState.controller.abort();
    }
    if (merlonsCollectionInfiniteState.fallbackRequest) {
        merlonsCollectionInfiniteState.fallbackRequest.abort();
        merlonsCollectionInfiniteState.fallbackRequest = null;
        merlonsCollectionInfiniteState.fallbackGrid = null;
    }
    merlonsCollectionInfiniteClearBusy(
        document.querySelector('[data-merlons-infinite-scroll]')
    );
};

function merlonsCollectionUpdateLoadProgress(grid) {
    var count = grid.querySelectorAll('.product--item[data-product-id]').length;
    var total = Math.max(0, Number(grid.getAttribute('data-total-products') || 0));
    document.querySelectorAll('#main-collection-filters .pagination__count .count').forEach(function (node) {
        node.textContent = String(count);
    });
    document.querySelectorAll('#main-collection-filters .pagination__bar').forEach(function (bar) {
        var barTotal = Math.max(0, Number(bar.getAttribute('data-max') || total));
        var progress = bar.querySelector('.progress');
        if (progress) {
            progress.style.width = (barTotal ? Math.min(100, count / barTotal * 100) : 0) + '%';
        }
    });
}

function merlonsCollectionRunCardEnhancements(grid) {
    try {
        if (typeof window.merlonsRebindCollectionCards === 'function') {
            window.merlonsRebindCollectionCards(grid);
        }
    } catch (error) {
        console.error('[Merlons collection cards]', error);
    }
    try {
        if ($('.AirReviews-Widget').length > 0 && typeof window.avadaAirReviewRerender === 'function') {
            window.avadaAirReviewRerender();
        }
    } catch (error) {
        console.error('[Merlons collection reviews]', error);
    }
    try {
        if (typeof novtheme.Countdown === 'function') novtheme.Countdown();
    } catch (error) {
        console.error('[Merlons collection countdown]', error);
    }
}

function merlonsCollectionCopyGridState(targetGrid, sourceGrid) {
    ['data-current-page', 'data-total-pages', 'data-total-products', 'data-next-url'].forEach(function (attribute) {
        if (sourceGrid.hasAttribute(attribute)) {
            targetGrid.setAttribute(attribute, sourceGrid.getAttribute(attribute));
        } else {
            targetGrid.removeAttribute(attribute);
        }
    });
}

function merlonsCollectionInfiniteLoad(root) {
    var state = merlonsCollectionInfiniteState;
    var grid = document.getElementById('product-grid');
    var fallback = root && root.querySelector('a[data-href]');
    var nextValue = fallback && (fallback.getAttribute('data-href') || fallback.getAttribute('href'));
    var nextUrl = merlonsCollectionUrl(nextValue);
    var currentStateKey = merlonsCollectionStateKey(window.location.href);
    var requestKey = merlonsCollectionRequestKey(nextUrl && nextUrl.href);

    if (!root || !root.isConnected || !grid || grid !== state.grid || state.inFlight || !nextUrl) return;
    if (merlonsCollectionInfiniteIsExcluded()) return;
    if (!requestKey || state.loadedUrls.has(requestKey)) {
        merlonsCollectionInfiniteFail(root, new Error('Repeated collection page URL was blocked.'));
        return;
    }
    if (!state.stateKey || state.stateKey !== currentStateKey || merlonsCollectionStateKey(nextUrl.href) !== currentStateKey) {
        merlonsCollectionInfiniteFail(root, new Error('Collection query state changed before the next page was loaded.'));
        return;
    }

    var requestedPage = Number(nextUrl.searchParams.get('page') || 0);
    if (requestedPage && requestedPage <= state.lastPage) {
        merlonsCollectionInfiniteFail(root, new Error('Out-of-order collection page was blocked.'));
        return;
    }

    var requestGeneration = state.generation;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var options = {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
    };
    if (controller) options.signal = controller.signal;
    state.controller = controller;
    state.inFlight = true;
    merlonsCollectionInfiniteDisconnect();
    root.classList.remove('is-error', 'is-complete');
    root.classList.add('is-loading');
    merlonsCollectionInfiniteStatus(root, 'loading');
    var container = document.getElementById('CollectionProductContainer');
    if (container) container.setAttribute('aria-busy', 'true');

    fetch(nextUrl.href, options)
        .then(function (response) {
            if (!response.ok) throw new Error('Collection page request failed: ' + response.status);
            return response.text();
        })
        .then(function (html) {
            if (
                requestGeneration !== state.generation
                || currentStateKey !== merlonsCollectionStateKey(window.location.href)
                || document.getElementById('product-grid') !== grid
                || !root.isConnected
            ) {
                return;
            }

            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var sourceContainer = parsed.getElementById('CollectionProductContainer');
            var sourceGrid = sourceContainer && sourceContainer.querySelector('#product-grid');
            var sourcePaging = sourceContainer && sourceContainer.querySelector('.paging');
            if (!sourceGrid) throw new Error('The next collection page has no product grid.');

            var sourcePage = Number(sourceGrid.getAttribute('data-current-page') || requestedPage || 0);
            if (sourcePage && sourcePage <= state.lastPage) {
                throw new Error('The next collection page did not advance.');
            }

            var sourceNext = sourcePaging && sourcePaging.querySelector('a[data-href]');
            var sourceNextValue = sourceNext && (sourceNext.getAttribute('data-href') || sourceNext.getAttribute('href'));
            if (sourceNextValue && merlonsCollectionStateKey(sourceNextValue) !== currentStateKey) {
                throw new Error('The returned pagination URL changed collection query state.');
            }

            var knownIds = new Set();
            grid.querySelectorAll('.product--item[data-product-id]').forEach(function (item) {
                knownIds.add(item.getAttribute('data-product-id'));
            });
            var sourceCards = Array.prototype.filter.call(sourceGrid.children, function (item) {
                return item.classList && item.classList.contains('product--item');
            });
            var fragment = document.createDocumentFragment();
            var appendedCount = 0;
            sourceCards.forEach(function (item) {
                var id = item.getAttribute('data-product-id');
                if (!id || knownIds.has(id)) return;
                knownIds.add(id);
                fragment.appendChild(document.importNode(item, true));
                appendedCount += 1;
            });
            if (!appendedCount && (sourceCards.length || sourceNextValue)) {
                throw new Error('The next collection page contained no new products.');
            }

            grid.appendChild(fragment);
            merlonsCollectionCopyGridState(grid, sourceGrid);
            state.loadedUrls.add(requestKey);
            state.lastPage = sourcePage || Math.max(state.lastPage + 1, requestedPage);

            var currentPaging = root.closest('.paging');
            if (sourcePaging && currentPaging) {
                currentPaging.replaceWith(document.importNode(sourcePaging, true));
            } else if (currentPaging) {
                currentPaging.remove();
            }

            merlonsCollectionUpdateLoadProgress(grid);
            merlonsCollectionRunCardEnhancements(grid);
            merlonsCollectionInfiniteClearBusy(root);
            merlonsCollectionInfiniteSetup({ loadedCount: appendedCount });
            document.dispatchEvent(new CustomEvent('merlons:collection:appended', {
                detail: { count: appendedCount, page: state.lastPage, url: nextUrl.pathname + nextUrl.search }
            }));
        })
        .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            if (requestGeneration !== state.generation) return;
            merlonsCollectionInfiniteFail(root, error);
        });
}

function merlonsCollectionInfiniteSetup(options) {
    options = options || {};
    merlonsCollectionInfiniteDisconnect();
    var state = merlonsCollectionInfiniteState;
    var grid = document.getElementById('product-grid');
    var root = document.querySelector('[data-merlons-infinite-scroll]');
    var button = $('.collection__btn-loadmore');

    button.off('click.merlonsCollectionLoadmore').on('click.merlonsCollectionLoadmore', function () {
        if (merlonsCollectionInfiniteIsExcluded()) return;
        var clickedButton = $(this);
        var currentGrid = $('.collection__grid-loadmore').first();
        var nextUrl = currentGrid.attr('data-next-url');
        var requestGeneration = state.generation;
        var requestStateKey = merlonsCollectionStateKey(window.location.href);
        var requestGrid = currentGrid.get(0);
        if (!nextUrl || clickedButton.hasClass('loading') || state.fallbackRequest || !requestGrid) return;
        clickedButton.addClass('loading').attr({
            'aria-busy': 'true',
            'data-loadmore-state': 'loading'
        });
        var request = $.ajax({ url: nextUrl, type: 'GET', dataType: 'html' });
        state.fallbackRequest = request;
        state.fallbackGrid = requestGrid;
        var requestIsCurrent = function () {
            return state.fallbackRequest === request
                && requestGeneration === state.generation
                && requestStateKey === merlonsCollectionStateKey(window.location.href)
                && requestGrid.isConnected
                && document.getElementById('product-grid') === requestGrid
                && currentGrid.attr('data-next-url') === nextUrl;
        };
        var recoverFallback = function (error) {
            if (!requestIsCurrent()) return;
            clickedButton.attr('data-loadmore-state', 'error');
            if (error) console.error('[Merlons collection load more]', error);
        };
        request
            .done(function (html) {
                if (!requestIsCurrent()) return;
                var sourceGrid = $(html).find('.collection__grid-loadmore').first();
                if (!sourceGrid.length) {
                    recoverFallback(new Error('The next collection page has no product grid.'));
                    return;
                }
                var knownIds = new Set();
                currentGrid.find('.product--item[data-product-id]').each(function () {
                    knownIds.add($(this).attr('data-product-id'));
                });
                sourceGrid.find('.product--item[data-product-id]').each(function () {
                    var id = $(this).attr('data-product-id');
                    if (!id || knownIds.has(id)) return;
                    knownIds.add(id);
                    currentGrid.append($(this).clone());
                });
                var returnedUrl = sourceGrid.attr('data-next-url');
                if (returnedUrl) currentGrid.attr('data-next-url', returnedUrl);
                else {
                    currentGrid.removeAttr('data-next-url');
                    clickedButton.remove();
                }
                merlonsCollectionUpdateLoadProgress(currentGrid.get(0));
                merlonsCollectionRunCardEnhancements(currentGrid.get(0));
                clickedButton.attr('data-loadmore-state', 'ready');
            })
            .fail(function (xhr, textStatus, errorThrown) {
                if (textStatus === 'abort' || (xhr && xhr.statusText === 'abort')) return;
                recoverFallback(errorThrown || new Error('Collection page request failed.'));
            })
            .always(function () {
                if (state.fallbackRequest === request) {
                    state.fallbackRequest = null;
                    state.fallbackGrid = null;
                }
                clickedButton.removeClass('loading').attr('aria-busy', 'false');
            });
    });

    if (!grid || !root) return;

    if (merlonsCollectionInfiniteIsExcluded()) {
        root.classList.remove('scroll__infitiny');
        root.classList.add('scroll__infitiny--managed', 'is-excluded');
        var excludedPaging = root.closest('.paging');
        if (excludedPaging) excludedPaging.hidden = true;
        return;
    }

    if (typeof window.IntersectionObserver !== 'function' || typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') {
        root.classList.remove('scroll__infitiny');
        root.classList.add('scroll__infitiny--managed', 'is-fallback');
        return;
    }

    root.classList.remove('scroll__infitiny', 'is-error', 'is-excluded');
    root.classList.add('scroll__infitiny--managed', 'is-enhanced');
    var paging = root.closest('.paging');
    if (paging) paging.hidden = false;

    var currentKey = merlonsCollectionStateKey(window.location.href);
    if (state.stateKey !== currentKey || state.grid !== grid) {
        state.generation += 1;
        if (state.controller) state.controller.abort();
        if (state.fallbackRequest) {
            state.fallbackRequest.abort();
            state.fallbackRequest = null;
            state.fallbackGrid = null;
        }
        merlonsCollectionInfiniteClearBusy(root);
        state.stateKey = currentKey;
        state.grid = grid;
        state.lastPage = Math.max(0, Number(grid.getAttribute('data-current-page') || root.getAttribute('data-current-page') || 0));
        state.loadedUrls = new Set();
    }

    var fallback = root.querySelector('a[data-href]');
    var nextValue = fallback && (fallback.getAttribute('data-href') || fallback.getAttribute('href'));
    if (!fallback || !nextValue) {
        root.classList.add('is-complete');
        merlonsCollectionInfiniteStatus(root, 'complete');
        return;
    }

    var nextKey = merlonsCollectionRequestKey(nextValue);
    if (
        !nextKey
        || state.loadedUrls.has(nextKey)
        || merlonsCollectionStateKey(nextValue) !== currentKey
    ) {
        merlonsCollectionInfiniteFail(root, new Error('Invalid next collection page URL.'));
        return;
    }

    if (typeof options.loadedCount !== 'undefined') {
        merlonsCollectionInfiniteStatus(root, 'loaded', options.loadedCount);
    } else {
        merlonsCollectionInfiniteStatus(root, 'loaded', 0);
        var initialStatus = root.querySelector('[data-merlons-infinite-status]');
        if (initialStatus) initialStatus.textContent = '';
    }
    state.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
            merlonsCollectionInfiniteLoad(root);
        }
    }, {
        root: null,
        rootMargin: '600px 0px',
        threshold: 0
    });
    state.observer.observe(root);
}

function merlonsCollectionInfiniteBindLifecycle() {
    var state = merlonsCollectionInfiniteState;
    if (state.listenersBound) return;
    state.listenersBound = true;
    document.addEventListener('merlons:collection:rendered', function () {
        window.requestAnimationFrame(function () {
            merlonsCollectionInfiniteSetup();
        });
    });
    document.addEventListener('shopify:section:load', function () {
        window.requestAnimationFrame(function () {
            merlonsCollectionInfiniteSetup();
        });
    });
    document.addEventListener('shopify:section:unload', window.merlonsCancelCollectionInfiniteScroll);
    window.addEventListener('popstate', window.merlonsCancelCollectionInfiniteScroll);
    window.addEventListener('pageshow', function () {
        window.requestAnimationFrame(function () {
            merlonsCollectionInfiniteSetup();
        });
    });
}

window.merlonsRefreshCollectionInfiniteScroll = function () {
    window.merlonsCancelCollectionInfiniteScroll();
    window.requestAnimationFrame(function () {
        merlonsCollectionInfiniteSetup();
    });
};

novtheme.CollectionPageLoadmore = function() {
    merlonsCollectionInfiniteBindLifecycle();
    merlonsCollectionInfiniteSetup();
};
novtheme.NovAccordion = function() {
    $('.nov-accordion').each(function() {
        var $accordion = $(this);

        if ($accordion.hasClass('first-open')) {
            $accordion.find('.nov-accordion__item:first-child .nov-accordion__title').addClass('act');
            $accordion.find('.nov-accordion__item:first-child .nov-accordion__content').slideDown();
        }

        $accordion.find('.nov-accordion__title').each(function() {
            var $title = $(this);
            var $content = $title.siblings('.nov-accordion__content');

            if (typeof responsive_mobile !== 'undefined' && responsive_mobile) {
                $title.removeClass('act');
                $title.parent().removeClass('act');
                $content.hide();
            }

            if ($title.hasClass('act')) {
                $title.parent().addClass('act');
                $content.show();
            }

            $title.off('click').on('click', function () {
                if ($title.hasClass('act')) {
                    $title.removeClass('act');
                    $title.parent().removeClass('act');
                    $content.slideUp();
                } else {
                    $accordion.find('.nov-accordion__title').removeClass('act');
                    $accordion.find('.nov-accordion__content').slideUp();
                    $accordion.find('.nov-accordion__item').removeClass('act');

                    $title.addClass('act');
                    $title.parent().addClass('act');
                    $content.slideDown();
                }
            });
        });
    });
};
novtheme.ObserverActive = function() {
    function observeIntersection(elements) {
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                const $element = $(entry.target);
                
                if (entry.isIntersecting) {
                    $element.addClass('act');
                } else {
                    $element.removeClass('act');
                }
            });
        };
        const margin = elements.data('margin');
        const options = {
            rootMargin: margin
        };
        elements.each(function(index, element) {
            const observer = new IntersectionObserver(observerCallback, options);
            observer.observe(element);
        });
    }

    const el = $('.el-parallax');
    const el2 = $('.block__parallax');
    const el3 = $('.block-ins');
    const el4 = $('.nov-scroll-view');

    observeIntersection(el);
    observeIntersection(el2);
    observeIntersection(el3);
    observeIntersection(el4);
};
novtheme.Parallax = function() {
    $(window).scroll(function(){
        $('.el-parallax.act').each(function(){
            var currentPosition = $(window).scrollTop(),
                offset_top = $(this).offset().top;
                if (currentPosition - offset_top < 0) {
                    var scrolled = (offset_top - currentPosition) * 0.1;
                    if (scrolled > 150) {
                        scrolled = 150
                    }
                    $(this).css('transform', 'translateY('+ scrolled+'px)');
                } else {
                    var scrolled = (currentPosition - offset_top) * 0.1;
                    if (scrolled > 150) {
                        scrolled = 150
                    }
                    $(this).css('transform', 'translateY(-'+ scrolled+'px)');
                }
        })
        $('.block__parallax.act').each(function(){
            var winHeight = $(window).height(),
                currentPosition = $(window).scrollTop(),
                section_id = $(this).children().data('section-id'),
                offset_top = $(this).offset().top,
                distanceY = offset_top - winHeight,
                scrolled = (currentPosition - distanceY) * 0.25,
                scrolledMax = $(this).width() - $(window).width();
                if (scrolled > scrolledMax) {
                   scrolled = scrolledMax;
                }
            $('#shopify-section-'+section_id+' .itemX_parallax').css('transform', 'translateX(-'+ scrolled+'px)');
            $('#shopify-section-'+section_id+' .reverseX_parallax').css('transform', 'translateX('+ scrolled+'px)');
        })
    });
};
novtheme.LookBook = function() {
    if ($('.item-lookbook').length > 0) {
        $('.item-lookbook').each(function () {
            var el = $(this),
            el_c = $(this).children('.content-lookbook'),
            t = el.position().top,
            l = el.position().left,
            ew = el.outerWidth(),
            h = el.offsetParent().height(),
            w = el.offsetParent().width(),
            c = el_c.width();
            if (w/2 < l) {
                el_c.css('right', (ew - 40)/2 + 52).addClass('p-left');
                if (w - l + c > w) {
                    el_c.css('margin-right', (w - l + c - w) * -1)
                }
            } else {
                el_c.css('left', (ew - 40)/2 + 52).addClass('p-right');
                if (l + ew + c > w) {
                    el_c.css('margin-left', (l + ew + c - w) * -1)
                }
            }
            /*if (h/2 < t) {
                if ($(window).width > 575) {
                    el_c.css('bottom', '60px')
                } else {
                    el_c.css('bottom', '35px')
                }
            } else {
                if ($(window).width > 575) {
                    el_c.css('top', '60px')
                } else {
                    el_c.css('top', '35px')
                }
            }*/
        })
    }
    $('.section-lookbook-product').each(function(){
        $(this).find('.nov_item_act').click(function(){
            var data = $(this).data('act');
            $(this).siblings().removeClass('act');
            $(this).parents('.container-inner').find('.nov_btn_act').removeClass('act');
            $(this).addClass('act');
            $('[data-toggle="'+ data +'"]').addClass('act');
        });
    });
};
novtheme.LanguageCountry = function() {
    $('.nov-language, .nov-country').each(function() {
        var el = $(this),
        input = el.find('input[name="locale_code"], input[name="country_code"]'),
        item =  el.find('.item');
        if (el.hasClass('flag')) {
            var flag = el.find('.active .flag-icon').html();
            el.find('.nov_ud_btn').prepend('<span class="flag-icon"></span>');
            el.find('.nov_ud_btn .flag-icon').html(flag);
        }
        item.click(function() {
            var value = $(this).data('value');
            input.val(value);
            el.submit();
        });
    });
};
novtheme.CartExtent = function() {
    var close = theme.strings.close_mini_canvas;
    $(document).on('click', '.extend--label__item', function(){
        var dataTitle = $(this).data('label'),
            item = $('.extend--label__item'),
            label = $('.cart_extend--label'),
            cartExtend = $('.cart_extend');
        if ($(this).hasClass("act")) {
            $(this).removeClass('act');
            cartExtend.removeClass('act');
            label.removeClass('act');
            $(this).attr('data-original-title', dataTitle);
        } else {
            var siblings = $(this).siblings();
            siblings.each(function () {
               var sibTitle = $(this).data('title');
               siblings.removeClass('act');
               $(this).attr('data-original-title', sibTitle);
            })
            cartExtend.removeClass('act');
            label.removeClass('act');
            $(this).addClass('act');
            $(this).attr('data-original-title', close);
            $('.cart_extend[data-content="' + dataTitle + '"]').addClass('act');
            label.addClass('act');
        }
        if (responsive_mobile) {
            $('.block_cart_canvas #desktop_cart').addClass('open-extend');
        }
    });
    $('.extend--label__item').hover(function(){
        var title = $(this).attr('title');
        if ($(this).hasClass("act")) {
            $(this).attr('data-original-title', close);
        } else {
            $(this).attr('data-original-title', title);
        }
    },function(){
        if ($(this).hasClass("act") && typeof title !== "undefined") {
            $(this).attr('data-original-title', title);
        } else {
            $(this).attr('data-original-title', close);
        }
    });
    $(document).on('click', '.cart_extend--btn', function(){
        $('.cart_extend, .cart_extend--label, .extend--label__item').removeClass('act')
        if (responsive_mobile) {
            $('.block_cart_canvas #desktop_cart').removeClass('open-extend');
        }
    });
    $(document).on('click', '.btn_save--discount', function(){
        var val = $(this).parent().find('input').val();
        $('.js-form-discount').val(val);
        $.cookie('discountCode', val, 30);
    });

    setTimeout(function() {
        var discountCode = $.cookie('discountCode');
        if (discountCode && discountCode.length) {
            $('.cart_extend--input[name="discount"]').val(discountCode);
        }
    }, 1000);
    
    if (responsive_mobile) {
        var height = $('#desktop_cart.item_count .block_cart_top').height();
        var flag = true;
        var offsetTop = 0;
        $('#desktop_cart').scroll(function() {
            var scrollTop = $('#desktop_cart').scrollTop();
            if (scrollTop > height) {
                $('#desktop_cart.item_count .block_cart_top').addClass('scroll-down');
            } else {
                $('#desktop_cart.item_count .block_cart_top').removeClass('scroll-down');
            }
            if (scrollTop < offsetTop && scrollTop > height) {
                if (flag == true) {
                    $('#desktop_cart.item_count .block_cart_top').removeClass('scroll-down').addClass('sticky-sm');
                    flag = false;
                }
            } else {
                if (flag == false) {
                    $('#desktop_cart.item_count .block_cart_top').addClass('scroll-down').removeClass('sticky-sm');
                    flag = true;
                }
            }
            offsetTop = scrollTop;
        });
    }
};
novtheme.AddActive = function() {
    function syncFilterSidebarTrigger(trigger, isOpen) {
        if (trigger.is('[data-toggle="FilterSidebar"][aria-expanded]')) {
            trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
        }
    }

    function toggleActiveButton(event) {
        if (event) event.preventDefault();
        var data = $(this).data('toggle');
        var overlay = $(this).data('overlay');
        $(this).siblings().removeClass('act');
        $(this).parents('.container-inner').find('.nov_item_act').removeClass('act');
        if ($(this).hasClass('act')) {
            $(this).removeClass('act');
            $('[data-act="'+ data +'"]').removeClass('act');
            body.removeClass(''+ data +'-open');
            syncFilterSidebarTrigger($(this), false);
            if (overlay == true) {
                sidebarOverlay.removeClass('act').removeAttr('data-close');
            }
        } else {
            $(this).addClass('act');
            $('[data-act="'+ data +'"]').addClass('act');
            body.addClass(''+ data +'-open');
            syncFilterSidebarTrigger($(this), true);
            if (overlay == true) {
                sidebarOverlay.addClass('act').attr('data-close', data);
            }
        }
    }

    $('.nov_btn_act')
        .off('click.merlonsAddActive')
        .on('click.merlonsAddActive', toggleActiveButton)
        .off('keydown.merlonsFilterSidebar')
        .on('keydown.merlonsFilterSidebar', function(event) {
            if (!$(this).is('[data-toggle="FilterSidebar"]')) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            toggleActiveButton.call(this, event);
        });
    $('.nov_btn_close').off('click.merlonsAddActive').on('click.merlonsAddActive', function(){
        var data = $(this).data('close');
        $('[data-act="'+ data +'"], .sidebar-overlay, .nov_btn_act').removeClass('act');
        sidebarOverlay.removeAttr('data-close');
        body.removeClass(''+ data +'-open');
        if (data === 'FilterSidebar') {
            var trigger = $('[data-toggle="FilterSidebar"][aria-expanded]').first();
            syncFilterSidebarTrigger(trigger, false);
            trigger.trigger('focus');
        }
    });
    $('[data-toggle="modal"]').click(function() {
        $('.nov_btn_act, .nov_item_act').removeClass('act');
        sidebarOverlay.removeClass('act');
    })
    $('[btn-toggle]').click(function () {
        var toggle = $(this).data('toggle');
        $(this).toggleClass('act');
        $('[nov-toggle="'+ toggle +'"]').slideToggle(400);
    })
};
novtheme.ParallaxImage = function() {
    if (currentWidth > 1023) {
        $('.img_animate').each(function() {
            var el = $(this);
            el.parallax();
        });
    }
};
novtheme.BtnSlider = function() {
    $('.nov-btn-click-slider').each(function() {
        var el = $(this),
            offsetLeft = el.offset().left,
            slider = el.find('.el-slider'),
            btn = el.find('.btn-slider__el'),
            left = el.find('.active').offset().left;
            width = el.find('.active').width();
            if (rtl == true) {
                slider.css('left', left + width - offsetLeft - 26);
            } else {
                slider.css('left', left - offsetLeft);
            }
        btn.click(function(){
            btn.parent().removeClass('active');
            var n_left = $(this).parent().offset().left;
            var n_width = $(this).parent().width();
            $(this).parent().addClass('active');
            slider.css('left', n_left + n_width - offsetLeft - 26);
        })
    })
};
novtheme.CollectionTab = function() {
    $('.nav-mobile').each(function(){
        var el = $(this);
        var t = el.find('.active').text();
        var h = el.find('.nav-mobile__title');
        h.text(t);
        el.find('.nav-link').click(function(){
            h.text($(this).text());
        })
    })
}
novtheme.NumberAnimate = function() {
    const targetElement = $('.number-animate');
    if (targetElement.length) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    targetElement.each(function () {
                        var el = $(this);
                        var delay = el.hasClass('first-load') ? 1500 : 200;

                        if (!el.hasClass('act')) {
                            el.addClass('act');
                            var rawNumber = el.attr('data-number');
                            let displayFormat = ',';

                            if (rawNumber.indexOf(',') > -1 && rawNumber.indexOf('.') === -1) {
                                displayFormat = ',';
                                var parsedNumber = parseFloat(rawNumber.replace(',', '.'));
                            } else {
                                displayFormat = '.';
                                var parsedNumber = parseFloat(rawNumber.replace(/,/g, ''));
                            }

                            el.prop('number', 0).delay(delay).animate({
                                number: parsedNumber
                            }, {
                                duration: 2000,
                                easing: 'linear',
                                step: function (e) {
                                    let isDecimal = String(rawNumber).includes(',') || String(rawNumber).includes('.');
                                    let text;
                                
                                    if (isDecimal) {
                                        if (displayFormat === ',') {
                                            text = e.toFixed(1).replace('.', ',');
                                        } else {
                                            text = e.toFixed(1);
                                        }
                                    } else {
                                        text = Math.ceil(e);
                                    }
                                
                                    $(this).text(text);
                                }
                                
                            });
                        }
                    });
                }
            });
        });

        targetElement.each(function () {
            observer.observe(this);
        });
    }
};
novtheme.FakeOrder = function() {
    setTimeout(function() {
       if ($('#nov-popup-fake-order').length > 0) {
           var fakeOrder = $('#nov-popup-fake-order');
           var orderData = $('#fake-order-data');
           var closefakeOrder = fakeOrder.find('.close-popup');
           var mobile = $('#nov-popup-fake-order').data('xs');
           var date = new Date();
           var time = fakeOrder.data('time');
           date.setTime(date.getTime() + time);
           var intervalId = setInterval(function() {
             insertRandomData(fakeOrder, orderData);
           }, time);
           if ($.cookie('FakeOrder') != 'closed') {
               intervalId
           } else {
               clearInterval(intervalId);
           }
           closefakeOrder.click(function() {
               $.cookie('FakeOrder', 'closed', {expires:1, path:'/'});
               fakeOrder.removeClass('act');
               clearInterval(intervalId);
           })
           if (mobile === false && currentWidth < 576) {
              fakeOrder.remove();
           }
           function insertRandomData(fakeOrder, orderData) {
               if (fakeOrder.hasClass('act')) {
                   fakeOrder.removeClass('act')
               } else {
                   var productImage = fakeOrder.find('.product-image');
                   var productTitle = fakeOrder.find('.product-title');
                   var productTime = fakeOrder.find('.time');
                   var productName = fakeOrder.find('.name');
                   var productLocal = fakeOrder.find('.local');

                   var productItems = $(orderData).find('.product-item');
                   var randomIndex = Math.floor(Math.random() * productItems.length);
                   var randomProductItem = productItems.eq(randomIndex);
                   var imgSrc = randomProductItem.data('img');
                   var title = randomProductItem.data('title');
                   var productLink = randomProductItem.data('src');

                   var dataTime = $(orderData).find('.time-item');
                   var randomIndex = Math.floor(Math.random() * dataTime.length);
                   var randomTimeItem = dataTime.eq(randomIndex);
                   var time = randomTimeItem.data('time');

                   var dataLocal = $(orderData).find('.location-item');
                   var randomIndex = Math.floor(Math.random() * dataLocal.length);
                   var randomLocalItem = dataLocal.eq(randomIndex);
                   var local = randomLocalItem.data('local');

                   var dataName = $(orderData).find('.name-item');
                   var randomIndex = Math.floor(Math.random() * dataName.length);
                   var randomNameItem = dataName.eq(randomIndex);
                   var name = randomNameItem.data('name');

                   productImage.attr('href', productLink).empty();
                   if (imgSrc) {
                       productImage.append($('<img>').attr({src: imgSrc, alt: title || ''}));
                   } else {
                       productImage.append(
                           $('<svg class="merlons-fake-order-placeholder" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 5h16v14H4zM7 15l3-3 2 2 2-2 3 3M9 9h.01" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>')
                       );
                   }
                   productTitle.text(title || '').attr('href', productLink);
                   productTime.text(time || '');
                   productName.text(name || '');
                   productLocal.text(local || '');
                   fakeOrder.addClass('act');
                   fakeOrder.find('a').unbind();
               }
           }
       } 
    }, 5000);
};
novtheme.VerticalMenu = function() {
    var el = $(".site-nav-vertical");
    var isDesktop = window.matchMedia('(min-width: 1200px)').matches;
    var isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1199px)').matches;
    var header4CategoryTriggers = $('.contentsticky_vertical .btn-vertical, .contentstickynew_vertical .btn-vertical');
    var header4CategoryPanels = $('#desktopVerticalMenu .site-nav-vertical, #mobileVerticalMenu .site-nav-vertical');
    var categoryControls = isDesktop ? 'desktopVerticalMenu' : (isTablet ? 'mobile_menu' : 'mobileVerticalMenu');
    header4CategoryTriggers.attr('aria-controls', categoryControls);
    if (isTablet && header4CategoryTriggers.length) {
        var mobileMenuIsOpen = $('#mobile_menu').hasClass('act');
        header4CategoryPanels.removeClass('act');
        header4CategoryTriggers.toggleClass('act', mobileMenuIsOpen).attr('aria-expanded', mobileMenuIsOpen ? 'true' : 'false');
    }
    if (isDesktop) {
        // Keep the desktop panel pre-laid-out and let CSS animate only opacity/
        // transform. Clearing legacy jQuery slide styles prevents a compressed
        // first frame when this initializer runs again after a resize.
        el.stop(true, true).removeAttr('style');
        $('.btn-vertical')
            .toggleClass('act', el.hasClass('act'))
            .attr('aria-expanded', el.hasClass('act') ? 'true' : 'false');
    }
    $('.btn-vertical').off('click.merlonsVerticalMenu keydown.merlonsVerticalMenu').on('click.merlonsVerticalMenu keydown.merlonsVerticalMenu', function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (event.type === 'keydown') event.preventDefault();
        var isDesktopViewport = window.matchMedia('(min-width: 1200px)').matches;
        var isTabletViewport = window.matchMedia('(min-width: 768px) and (max-width: 1199px)').matches;
        if(isDesktopViewport) {
            var trigger = $(this),
                menu = trigger.closest('.header-vertical-menu').find('.site-nav-vertical').first();
            if (!menu.length) menu = el.first();
            var willOpen = !menu.hasClass('act');
            menu.stop(true, true).removeAttr('style').toggleClass('act', willOpen);
            $('.btn-vertical').toggleClass('act', willOpen).attr('aria-expanded', willOpen ? 'true' : 'false');
        } else if (isTabletViewport && header4CategoryTriggers.filter(this).length && novtheme.mobileMenu && typeof novtheme.mobileMenu.toggle === 'function') {
            header4CategoryPanels.removeClass('act');
            novtheme.mobileMenu.toggle($(this));
        } else {
            el.addClass('act');
            sidebarOverlay.addClass('act');
        }
    });
    // Show sub menu canvas tablet
    el.find('.site-nav__link--main .nav-direc').off('click').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parents('.nav--lv1').find('.nav-dropdown--lv1').slideUp(300);
        } else {
            $('.site-nav-vertical .nav-dropdown--lv1').slideUp(300);
            $('.site-nav-vertical .site-nav__link--main .nav-direc').removeClass('active');
            $(this).addClass('active');
            $(this).parents('.nav--lv1').find('.nav-dropdown--lv1').slideDown(300);
        }
    });

    // Show sub children menu canvas tablet
    $('.site-nav-vertical .site-nav__link--second .nav-direc').off('click').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parents('.nav--lv2').find('.nav-dropdown--lv2').slideUp(300);
        } else {
            $('.site-nav-vertical .nav-dropdown--lv2').slideUp(300);
            $('.site-nav-vertical .site-nav__link--second .nav-direc').removeClass('active');
            $(this).addClass('active');
            $(this).parents('.nav--lv2').find('.nav-dropdown--lv2').slideDown(300);
        }
    });

    let desktopContent = $('#desktopVerticalMenu');
    let mobileContent = $('#mobileVerticalMenu');

    if (!isDesktop) {
        if (desktopContent.children().length) {
            mobileContent.append(desktopContent.children().detach());
            if ($('.site-nav-vertical').hasClass('act')) {
                sidebarOverlay.addClass('act');
            }
        }
    } else {
        if (mobileContent.children().length) {
            desktopContent.append(mobileContent.children().detach());
            sidebarOverlay.removeClass('act');
        }
    }
};
novtheme.OverlayBlur = function () {
    var hoverTimer;
    $('.nov_overlay_blur').each(function() {
        var overlayBlur = $(this);
        var respon = '';
            respon = overlayBlur.data('respon');
        if (typeof respon === 'undefined') {
            respon = 1;
        }
        if (currentWidth >= respon) {
            overlayBlur.hover(
                function() {
                    hoverTimer = setTimeout(function() {
                        $('body').append('<div class="overlay-blur"></div>');
                        var offsetTop = overlayBlur.offset().top;
                        var height = overlayBlur.outerHeight();
                        var overlayHeight = $(window).height() * 2 - offsetTop - height;
                        $('.overlay-blur').css({'height': overlayHeight, 'top': offsetTop + height, 'z-index': '2'});
                    }, 150);
                },
                function() {
                    clearTimeout(hoverTimer);
                    $('body').find('.overlay-blur').fadeOut(200, function() {
                        $(this).remove();
                    });
                }
            );
        }  
    });
};
novtheme.ToggleUpDown = function () {
    $('.nov_ud_toggle').each(function(){
        var el = $(this),
            btn = el.find('.nov_ud_btn'),
            dropdown = el.find('.nov_ud_dropdown'),
            group = el.find('.nov_ud_group'),
            repon = el.data('ud_respon'),
            collapse = el.data('ud_collapse');
        
        if (typeof repon !== 'undefined') {
            if ($(window).width() <= repon) {
                btn.on('click', function() {
                    var groupA = $(this).closest(group);
                    if (collapse == true) {
                       groupA.siblings().removeClass('act').find(dropdown).slideUp();
                    }
                    groupA.toggleClass('act').find(dropdown).slideToggle();
                });
            }
        } else {
            btn.on('click', function() {
                var groupA = $(this).closest(group);
                if (collapse == true) {
                   groupA.siblings().removeClass('act').find(dropdown).slideUp();
                }
                groupA.toggleClass('act').find(dropdown).slideToggle();
            });
            $(document).on("click", function(event){
                if(!$(event.target).closest(el).length){
                    el.find(dropdown).slideUp();
                    group.removeClass('act')
                }
            });
        }
    });
};
novtheme.Comparisons = function () {
    $(".content-img-compare").each(function () {
        $(this).find(".nov-before-after .nov-ba-wrap:not(.init)").each(function () {
            initBeforeAfterEl($(this).addClass("init"));
        });
    });

    function initBeforeAfterEl($container) {
        const $parentElement = $container.closest(".content-img-compare");
        const $before = $parentElement.find(".before");
        const $handle = $parentElement.find(".handle");
        const $beforeHeader = $parentElement.find(".nov-before-header");
        const $afterHeader = $parentElement.find(".nov-after-header");
        const maxX = $container.outerWidth();
        const offsetX = $container.offset().left;

        function updatePosition(clientX) {
            let curPos = ((clientX - offsetX) / maxX) * 100;
            curPos = Math.max(0, Math.min(curPos, 100));

            $before.css({ right: 100 - curPos + "%" });
            $handle.css({ left: curPos + "%" });
            //$beforeHeader.css({ opacity: 1 - (100 - curPos) / 100 });
            //$afterHeader.css({ opacity: (100 - curPos) / 100 });
        }

        function handleMove(e) {
            updatePosition(e.type.includes('touch') ? e.originalEvent.changedTouches[0].pageX : e.clientX);
        }

        function handleUp() {
            $(document).off("mousemove touchmove", handleMove).off("mouseup touchend", handleUp);
        }

        function handleDown(e) {
            updatePosition(e.type.includes('touch') ? e.originalEvent.changedTouches[0].pageX : e.clientX);
            $(document).on("mousemove touchmove", handleMove).on("mouseup touchend", handleUp);
        }

        $handle.on('ontouchstart' in window ? "touchstart" : "mousedown", handleDown);
    }
};
novtheme.Marquee = function() {
    $('.nov-marquee:not(.nov-marquee--service-cards)').each(function () {
        $(this).find('.block-marquee-item').each(function () {
            const $clone = $(this).clone(true);
            $(this).after($clone);
        });
    
        setTimeout(() => {
            $(this).addClass('animating');
        }, 500);
    });
};
novtheme.TextAnimate = function() {
    const el = $('.text-animate-js');

    function observeIntersection(elements) {
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                const $element = $(entry.target);

                if (entry.isIntersecting && !$element.data('animated')) {
                    $element.data('animated', true);

                    var words = $element.text(),
                        arrayString = [words],
                        part = "",
                        offset = 0,
                        speed = 70;

                    const wordflick = function () {
                        if (offset <= arrayString[0].length) {
                            part = arrayString[0].substr(0, offset);
                            $element.text(part);
                            offset++;

                            setTimeout(wordflick, speed);
                        }
                    };

                    wordflick();
                }
            });
        };

        const margin = elements.data('margin') || "0px";
        const options = {
            rootMargin: margin
        };

        elements.each(function (index, element) {
            const observer = new IntersectionObserver(observerCallback, options);
            observer.observe(element);
        });
    }
    observeIntersection(el);
};
novtheme.BlockOverflowScroll = function() {
    const sectionContents = document.querySelectorAll('.block-overflow-scroll');

    sectionContents.forEach((sectionContent) => {
      let isDown = false;
      let startX;
      let scrollLeft;
      let isDragging = false;
      const minMoveDistance = 5;

      sectionContent.addEventListener('mousedown', (e) => {
        if (e.target.tagName.toLowerCase() === 'a' || e.target.closest('a')) {
          e.preventDefault();
        }

        isDown = true;
        isDragging = false;
        sectionContent.classList.add('active');
        startX = e.pageX - sectionContent.offsetLeft;
        scrollLeft = sectionContent.scrollLeft;
      });

      sectionContent.addEventListener('mouseleave', () => {
        isDown = false;
        sectionContent.classList.remove('active');
      });

      sectionContent.addEventListener('mouseup', () => {
        isDown = false;
        sectionContent.classList.remove('active');
        if (isDragging) {
          document.body.style.pointerEvents = 'none';
          setTimeout(() => {
            document.body.style.pointerEvents = '';
          }, 200);
        }
      });

      sectionContent.addEventListener('mousemove', (e) => {
        if (!isDown) return;

        e.preventDefault();

        const x = e.pageX - sectionContent.offsetLeft;
        const walk = x - startX;

        if (Math.abs(walk) >= minMoveDistance) {
          isDragging = true;
          sectionContent.scrollLeft = scrollLeft - walk;
        }
      });

      const links = sectionContent.querySelectorAll('a');
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          if (isDragging) {
            e.preventDefault();
          }
        });
      });
    });
};
novtheme.ElementHeight = function() {
    $('.js-height').each(function () {
        var el = $(this);
        var height = el.outerHeight();
        var maxHeight = el.data('max_height');
        el.css('--height', height + 'px');
        if (maxHeight != undefined) {
            el.css('--max-height', maxHeight + 'px');
        }
    })
}
novtheme.ScrollView = function() {
    if ($('.nov-scroll-view').length > 0) {
        window.addEventListener('scroll', () => {
            const container = document.querySelector('.nov-scroll-view');
            const blocks = container.querySelectorAll(':scope > .shopify-block');
        
            const containerRect = container.getBoundingClientRect();
            const containerHeight = container.offsetHeight;
        
            const scrollTop = Math.min(Math.max(-containerRect.top, 0), containerHeight - window.innerHeight);
            const scrollProgress = scrollTop / (containerHeight - window.innerHeight);
        
            blocks.forEach((block, i) => {
                block.style.top = `${14 + i * 3}vh`;
                const remain = blocks.length - i - 1;
                block.style.marginBottom = `${remain * 4}vh`;
                const maxBlocks = blocks.length;
                const minScale = 0.9 + (i / (maxBlocks - 1)) * (1 - 0.9);
                const scale = 1 - (1 - minScale) * scrollProgress;
                block.style.transform = `scale(${scale})`;
            });
        });
    }
}
$(document).ready(function() {
    $(novtheme.init);
    var timer = false;
    $(window).on('resize', function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function(){
            novtheme.CollectionPage();
            novtheme.toggleMobileStyles();
            novtheme.load_canvas_menu();
            novtheme.VerticalMenu();
            if ($(window).width() > 575) {
                $('.block_footer').find('.block-content.h_t').slideDown(300);
                $('.f_btn_sl').removeClass('active'); 
            } else {
                $('.block_footer').find('.block-content.h_t').slideUp(300);
            }
        }, 300);
    });
    if ($("#popup-subscribe").length) {
        $(window).on('load', function() {
            setTimeout(function() {
                novtheme.PopupNewletter();
            }, 2000);
        });
    }
    if ($("#popupAlert").length) {
        $(window).on('load', function() {
            $('#popupAlert').modal();
        });
        $("#popupAlert").click(function(){
            const url = window.location.href;
            const questionMarkIndex = url.indexOf('?customer');
            if (questionMarkIndex !== -1) {
                const previousLink = url.slice(0, questionMarkIndex);
                history.pushState({}, '', previousLink);
            }
        })
    }

    sidebarOverlay.on('click', function() {
        // Run the drawer lifecycle before the shared overlay clears its classes.
        if (novtheme.mobileMenu && $('#mobile_menu').hasClass('act')) novtheme.mobileMenu.close(true);
        $(this).removeClass('act');
        var data = $(this).data('close');
        $('.cart_extend, .cart_extend--label, #mobile_menu, #show-megamenu, .site-nav--btn, .nov_item_act, .nov_btn_act, #mobileVerticalMenu .site-nav-vertical').removeClass('act');
        $("#desktop_cart, #AccessibleNav").removeClass('active');
        body.css('overflow', 'auto').removeClass('open-canvans-cart, '+ data +'-open');
        body.removeClass('overflow_hidden');
        $(this).removeAttr('data-close');
        $('.extend--label__item').removeClass('act').each(function() {
            var title = $(this).data('title');
            $(this).attr('data-original-title', title);
        });
    });

    // Animate load wislist page detail
    $('.group-quantity .btnProductWishlist').click(function () {
        if($(this).hasClass('whislist-added')) {
            $('#popup-Wishlist').removeClass('novload')
        } else {
            $('#popup-Wishlist').addClass('novload')
        }
    })
    
    // Zoom Product Image Page Detail
    function ZoomProductImage(elements) {
        const canHoverZoom = window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)');
        const minimumZoomRatio = 1.08;
        const setZoomFallback = ($element, zoomUrl) => {
            const $host = $element.parent('.merlons-product-zoom');
            if ($host.length) {
                $host.trigger('zoom.destroy');
                $host.children('.zoomImg').remove();
            }
            $element
                .removeClass('merlons-zoom-ready')
                .addClass('merlons-zoom-fallback')
                .attr('data-merlons-zoom-url', zoomUrl)
                .removeAttr('data-merlons-zoom-loading');
        };
        const initializeZoom = (element) => {
            const $element = $(element);
            const zoomUrl = $element.attr('data-zoom');
            if (!canHoverZoom.matches || !zoomUrl || $element.attr('data-merlons-zoom-loading') === 'true') return;
            if ($element.attr('data-merlons-zoom-url') === zoomUrl
                && ($element.hasClass('merlons-zoom-ready') || $element.hasClass('merlons-zoom-fallback'))) return;

            $element.attr('data-merlons-zoom-loading', 'true');
            const probe = new Image();
            probe.onload = () => {
                if (!document.documentElement.contains(element)) return;
                const elementWidth = $element.outerWidth();
                const elementHeight = $element.outerHeight();
                const hasUsefulResolution = elementWidth > 0
                    && elementHeight > 0
                    && probe.naturalWidth >= elementWidth * minimumZoomRatio
                    && probe.naturalHeight >= elementHeight * minimumZoomRatio;

                if (!canHoverZoom.matches || !hasUsefulResolution) {
                    setZoomFallback($element, zoomUrl);
                    return;
                }

                let $host = $element.parent('.merlons-product-zoom');
                if (!$host.length) {
                    $element.wrap('<span class="merlons-product-zoom w-100" style="display:block"></span>');
                    $host = $element.parent();
                } else {
                    $host.trigger('zoom.destroy');
                    $host.children('.zoomImg').remove();
                }
                $element
                    .removeClass('merlons-zoom-fallback')
                    .addClass('merlons-zoom-ready')
                    .attr('data-merlons-zoom-url', zoomUrl)
                    .removeAttr('data-merlons-zoom-loading');
                $host.zoom({
                    url: zoomUrl,
                    touch: false
                });
                setTimeout(() => {
                    // The original image supplies the description; the zoom overlay is decorative.
                    $host.children('.zoomImg').attr({ alt: '', 'aria-hidden': 'true' });
                }, 0);
            };
            probe.onerror = () => setZoomFallback($element, zoomUrl);
            probe.src = zoomUrl;
        };
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    initializeZoom(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        };
        elements.each(function (index, element) {
            const observer = new IntersectionObserver(observerCallback);
            observer.observe(element);
        });
    }

    const el = $('.image-zoom');
    ZoomProductImage(el);

    // Form newletter product soldout
    $('.no-view').click(function () {
        if($('.contact-form').hasClass('add')) {
            $('.contact-form').removeClass('add')
        } else {
            $('.contact-form').addClass('add')
        }
    });

    // Accordion footer mobile
    $(".f_btn_sl").click(function(e) {
        if ($(this).hasClass("active")) {
            $(this).removeClass('active');
            $(this).parents('.menu-block').find('.block-content.h_t').slideUp(300);
        } else {
            $(this).addClass('active');
            $(this).parents('.menu-block').find('.block-content.h_t').slideDown(300);
        }
    });

    $(".faqs-main .panel-header").click(function(e) {
        if ($(this).hasClass("collapsed")) {
            $(".faqs-main").removeClass('active');
            $(this).parents('.faqs-main').addClass('active');
        } else {
            $(this).parents('.faqs-main').removeClass('active');
        }
    });

    $('.promotion-close').click(function () {
        $('[promationBar]').slideUp(300).removeClass('act');
    })

})
